import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      logout: "Logout", close: "Close", cancel: "Cancel", back: "Back", booking: "Booking", gps_denied: "GPS permission denied",
      wallet: "Wallet", history: "History", inbox: "Inbox", ride_requests: "Ride Requests", whatsapp_support: "WhatsApp Support",
      menu: "Menu", wallet_balance: "Wallet Balance", pending_savings: "Pending Savings", last_ride_info: "Last Ride Info",
      select_pickup: "Click on map to select Pickup", select_destination: "Click on map to select Destination", distance: "Distance", fare: "Fare", savings: "Savings",
      select_service: "Select Service", request_ride: "Request Ride", call: "Call", chat: "Chat", accept_ride: "Accept Ride Request",
      new_request: "New Request", your_passenger: "Your Passenger", enter_key: "Enter Product Key", phone: "Phone", area: "Area", map: "Map", license: "License", support: "Support",
      kinamarket: "KinaMarket",
      whatsapp: "WhatsApp",
      accept_to_view: "Accept ride to view contact & area details",





      signup_failed:
  "Signup failed. Please try again.",

email_already_exists:
  "This email is already registered.",

invalid_email:
  "Invalid email address.",

weak_password_error:
  "Password must be at least 6 characters.",

network_error:
  "Network error. Check your internet connection.",
complete_all_ride_fields:
  "Complete all ride fields!",

complete_all_rental_fields:
  "Complete all rental fields and select pickup on map!",
pickup: "Pickup",
dropoff: "Drop Off",
      install_global: "Global Transport & Marketplace Platform",

install_services: "Available Services",

install_button: "Install KinaTrip App",

app_screenshots: "App Screenshots",

taxi_booking: "🚕 Taxi Booking",
bus_transport: "🚌 Bus Transport",
motorbike: "🏍 Motorbike",
boat_transport: "🚤 Boat Transport",
delivery_services: "📦 Delivery Services",
rental_cars: "🚗 Rental Cars",

copyright:
  "© 2026 KinaTrip Technologies Ltd. All Rights Reserved.",
back_to_map: "⬅ Back to Map",
enter_fare: "Enter Fare",

click_pickup_map: "📍 Click map to select Pickup Location",
click_dropoff_map: "🏁 Click map to select Drop-off Location",

pickup_placeholder:
  "📍 Pickup Location or Click Map",

dropoff_placeholder:
  "🏁 Drop-off Location or Click Map",

back_to_menu: "⬅ Back to Menu",

select_date: "📅 Select Date",
select_time: "⏰ Select Time",

online: "Online",
offline: "Offline",

search_location: "Search location...",

driver_arriving: "Driver Arriving",
ride_completed: "Ride Completed",

payment_successful: "Payment Successful",
payment_failed: "Payment Failed",

withdraw_success: "Withdrawal Successful",
withdraw_pending: "Withdrawal Pending",




ready: "Ready",
locked: "Locked",
withdrawal_unlocked: "Withdrawal unlocked",
needed_unlock: "needed more to unlock withdrawal",
pending_withdrawals: "Pending Withdrawals",
total_spent: "Total Spent",
total_saved: "Total Saved",
withdrawn: "Withdrawn",
request_withdrawal: "Request Withdrawal",
wallet_transactions: "Wallet Transactions",
withdrawal_request: "Withdrawal Request",
ride_savings: "Ride Savings",
no_transactions: "No transactions yet",
processing: "Processing...",
enter_account: "Phone or Account Number",
enter_amount: "Enter amount",
saved: "Saved",
reply: "Reply",
reply_comment: "Write reply...",
recent_drivers: "Recent Drivers",
no_recent_drivers: "No recent drivers",
create_post: "Create Post",
write_caption: "Write something...",
pics: "Pictures",
posting: "Posting...",
write_comment: "Write comment...",
send: "Send",
weekly_spending: "Weekly Spending",
ride_log: "Ride Log",
no_rides: "No rides yet",


no_pickup_recorded: "No pickup recorded",
no_destination_recorded: "No destination recorded",
      finance: "Finance",
expired: "Expired",

driver: "Driver",
now: "Now",
minutes_ago: "m ago",
hours_ago: "h ago",
days_ago: "d ago",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Receipt",
select_transaction_receipt: "Select a transaction below to view receipt.",
post_failed: "Post failed",
monday: "Monday",
tuesday: "Tuesday",
wednesday: "Wednesday",
thursday: "Thursday",
friday: "Friday",
saturday: "Saturday",
sunday: "Sunday",
feed: "Feed",
live: "Live",
recent: "Recent",
total_rides: "Total Rides",
completed: "Completed",
dropoff: "Drop-off",
not_logged: "Not Logged",
no_history: "No history",
ride_history_dashboard: "Ride History Dashboard",
weekly_revenue: "Weekly Revenue",
total_revenue: "Total Revenue",
search_passenger_location_phone: "Search passenger, location, phone...",
all: "All",
accepted: "Accepted",
export: "Export",
receipts: "Receipts",
no_phone: "No phone",
no_ride_history: "No ride history yet.",
whats_happening: "What's happening on KinaHub?",
video_selected: "Video selected",
image_selected: "Image selected",
remove: "Remove",
pictures: "Pictures",
videos: "Videos",
mood: "Mood",
post: "Post",
public: "Public",
likes: "likes",
comments: "comments",
shares: "shares",
like: "Like",
comment: "Comment",
share: "Share",
post_link_copied: "Post link copied",
write_comment: "Write comment...",
private_account_section: "This is a private account section.",
kinatrip_finance_wallet: "KinaTrip Finance Wallet",
lifetime_gross_earnings: "Lifetime Gross Earnings",
available_balance: "Available Balance",
today: "Today",
this_week: "This Week",
this_month: "This Month",
this_year: "This Year",
finance_actions: "Finance Actions",
transaction_records: "Transaction Records",
export_report: "Export Report",
tax_summary: "Tax Summary",
weekly_earnings: "Monday - Sunday Earnings",
search_transaction: "Search transaction, passenger, phone...",
passenger_ride: "Passenger Ride",
gross: "Gross",
platform_fee: "Platform Fee",
net: "Net",
no_finance_transactions: "No finance transactions yet.",
kinahub_live_center: "KinaHub Live Center",
go_live: "Go Live",
upload_reel: "Upload Reel",
online_status: "Online Status",
safety_alert: "Safety Alert",
owner: "Owner",
viewer: "Viewer",
access: "Access",
visibility: "Visibility",
no_live_videos: "No live videos or reels yet.",
live_link_copied: "Live link copied",


assign_kinatrip_driver: "Assign KinaTrip Driver",
buyer_confirm_received: "Buyer Confirm Received",
release_escrow_to_seller: "Release Escrow to Seller",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Cash",
seller_location: "Seller Location",
buyer_location: "Buyer Location",
user: "User",
payment: "Payment",
delivery: "Delivery",
status: "Status",
buyer: "Buyer",
send: "Send",
type_message: "Type your message...",
complete_all_fields: "Complete all fields.",
please_upload_receipt: "Please upload receipt.",
cash_deposit_success: "Cash deposit submitted successfully.",



     service_taxi: "Taxi",
service_bus: "Bus",
service_rental: "Rental Car",
service_boat: "Boat",
service_delivery: "Delivery Truck",
service_motorbike: "Motorbike",

      direct_ride_requested: "Direct ride requested!",
      ride_broadcasted: "Ride request broadcast to all drivers!",

paypal_payment: "PayPal Payment", // English
category_electronics: "Electronics",
category_fashion: "Fashion",
category_home: "Home & Living",
category_food: "Food",
category_auto_parts: "Auto Parts",
category_stationery: "Stationery",
category_services: "Services",
category_other: "Other",
ride_accepted_success: "Ride accepted successfully!",

receipt_uploaded: "Receipt uploaded successfully",
no_file_selected: "No file selected",

market_item: "Market Item",

market_buy_message: "Hello, I want to buy this item:",
for_price: "for",
all_listings: "All Listings",
driver_listings: "Driver Listings",
passenger_listings: "Passenger Listings",
business_listings: "Business Listings",
verified_sellers: "Verified Sellers",

seller_orders: "Seller Orders / Chats",
accept_order: "Accept Order",
seller_review: "Seller Review",
awaiting_payment: "Awaiting Payment",
escrow_holding: "Escrow Holding",
driver_assigned: "Driver Assigned",
delivered: "Delivered",
escrow_released: "Escrow Released",
cash_deposit_verification: "Cash Deposit Verification",
deposit_instruction:
  "Deposit to KinaTrip approved account and submit details below.",
submit_cash_deposit: "Submit Cash Deposit",
loading_chat: "Loading chat...",
payment_failed_start: "Payment failed to start",



premium: "Premium",
days_label: "Days",
select_payment_type: "Select Payment Type",
cash_deposit: "Cash Deposit",
amount_paid: "Amount Paid",
pay: "Pay",
securely_using: "securely using",
stripe_payment: "Stripe — International Payments",
flutterwave_payment: "Flutterwave — Africa",
xendit_payment: "Xendit — Asia",
activate_free_trial: "Activate Free Trial",
trial_active: "Trial Active",
trial_activated_success: "Trial License Activated Successfully!",
submit_cash_payment: "Submit Cash Payment",
payment_screenshot_alt: "Payment Screenshot",



license_trial: "Trial License",
license_standard: "Standard License",
license_silver: "Silver License",
license_gold: "Gold License",
free: "Free",
fee: "Fee",
validity: "Validity",
daily_limit: "Daily Limit",
passengers: "Passengers",
unlimited_passengers: "Unlimited Passengers",

select_license_plan: "Select License Plan",

online_card_payment: "Online Card Payment",
secure_payment_text:
  "Your card details are securely handled by certified payment gateways.",

cash_deposit_payment: "Manual / Local Partner Payment",

pay_through_partner:
  "Pay through your approved KinaTrip Country Partner or local payment agent.",

country: "Country",
plan: "Plan",
amount: "Amount",

full_name: "Full Name",
phone_number: "Phone Number",

receipt_reference: "Receipt / Reference / Partner Code",

upload_receipt:
  "Upload Payment Receipt / Screenshot",

submit_payment: "Submit Payment",

waiting_approval:
  "Payment submitted successfully. Waiting for admin approval.",

back_to_payment_type: "Back to Payment Type",


select_user_type: "Select user type",
passenger: "Passenger",
driver_service_provider: "Driver / Service Provider",
already_have_account: "Already have an account? Login",
dont_have_account: "Don't have an account? Signup",
login: "Login",
signup: "Signup",
email: "Email",
password: "Password",
confirm_password: "Confirm Password",
phone: "Phone",
city: "City",
state_province: "State/Province",
full_name: "Full Name",
business_service_name: "Business / Service Name",
upload_profile_photo: "Upload Profile Photo:",
please_wait: "⌛ Please wait…",
select_service_default: "-- Select Service --",
passwords_match: "✅ Passwords match",
passwords_not_match: "❌ Passwords do not match",
strength: "Strength",

choose_file: "Choose File",
weak: "Weak",
medium: "Medium",
strong: "Strong",


escrow_active: "Escrow Active",
transport_provided_by_kinatrip: "Transport provided by KinaTrip",
list_item_for_sale: "List an Item for Sale",
what_are_you_selling_today: "What are you selling today?",
enter_price: "Enter price",
select_category: "Select category",
photo: "Photo",
price: "Price",
category: "Category",
post_item: "Post Item",
posting: "Posting...",
trending_items: "Trending Items",
no_market_items_yet: "No market items yet.",
buy_now: "Buy Now",
market_item: "Market Item",
no_city: "No City",
no_country: "No Country",
escrow_description: "KINATRIP ESCROW: Funds are held safely until you confirm receipt of your item. Pay online, and our drivers deliver it to your door.",

      minutes: "min",
"Driver": "Driver",
"Choose Driver": "Choose Driver",
"With Driver": "With Driver",
"Self Driver": "Self Driver",
"Driver": "Driver",

    // ADD THIS BELOW your existing keys

passenger_vehicles: "Passenger Vehicles",
marine: "Marine",
cargo_transport: "Cargo & Transport",
machinery_equipment: "Machinery & Equipment",

vehicle_economy: "Economy",
vehicle_sedan: "Sedan",
vehicle_suv: "SUV / 4WD",
vehicle_van: "Van",
vehicle_minibus: "Minibus",
vehicle_bus: "Bus / PMV",
vehicle_pickup: "Pickup",
vehicle_luxury: "Luxury",
vehicle_taxi: "Taxi",
vehicle_motorbike: "Motorbike",

vehicle_boat: "Boat / Dinghy",

vehicle_cargo_van: "Cargo Van",
vehicle_truck: "Truck",
vehicle_trailer: "Trailer",

vehicle_forklift: "Forklift",
vehicle_excavator: "Excavator",
vehicle_bulldozer: "Bulldozer",
vehicle_grader: "Grader",
vehicle_loader: "Loader",
vehicle_roller: "Roller",
vehicle_crane: "Crane",
vehicle_tractor: "Tractor",
vehicle_generator: "Generator",

vehicle_other: "Other",


pickup_location: "Pickup Location",
return_location: "Return Location",
select_vehicle_type: "Select Vehicle Type",
offer_per_day: "Offer Per Day",
offer_per_day_label: "Offer / Day",
total_will_be: "Total will be",
grand_total: "Grand Total",
request_rental: "Request Rental",
optional_rental_note: "Optional: Driver needed, AC required, early pickup, fuel included...",

pickup_required: "Pickup required",
return_required: "Return required",
select_vehicle: "Select vehicle",
invalid_days: "Invalid days",
offer_per_day_required: "Offer per day required",
pickup_date_required: "Pickup date required",
pickup_time_required: "Pickup time required",
return_date_required: "Return date required",
return_time_required: "Return time required",
return_must_be_after_pickup: "Return must be after pickup",

pickup: "Pickup",
return: "Return",
vehicle: "Vehicle",
days: "Days",
pickup_time: "Pickup Time",
return_time: "Return Time",
eta: "ETA",
minutes: "min"

    }
  },

  tpi: {
    translation: {
      logout: "Logaut", close: "Pasim", cancel: "Kansel", back: "Go Bek", booking: "Boking", gps_denied: "No gat permisen long yusim GPS",
      wallet: "Woket", history: "Histori", inbox: "Inboks", ride_requests: "Kisim Kar", whatsapp_support: "WhatsApp Sapot",
      menu: "Menyu", wallet_balance: "Mani long Woket", pending_savings: "Sivings i stap yet", last_ride_info: "Infomesen long las raun",
      select_pickup: "Klikim map long makim Pikap", select_destination: "Klikim map long makim Destinesen", distance: "Longwe", fare: "Fea", savings: "Sivings",
      select_service: "Makim Sevis", request_ride: "Kisim Kar", call: "Ringim", chat: "Toktok", accept_ride: "Kisim dispela raun",
      new_request: "Nupela askim", your_passenger: "Pasindia bilong yu", enter_key: "Putim Key", phone: "Namba", area: "Hap", map: "Map", license: "Laisens", support: "Sapot",
      kinamarket: "KinaMaket",
      whatsapp: "WhatsApp",
      accept_to_view: "Kisim dispela raun bilong lukim namba na hap",






      signup_failed:
  "Signup i no kamap. Traim gen.",

email_already_exists:
  "Dispela email i stap pinis.",

invalid_email:
  "Email address i no stret.",

weak_password_error:
  "Password i mas gat 6 o moa characters.",

network_error:
  "Network problem. Lukim internet connection.",
complete_all_ride_fields:
  "Plis pulimap olgeta ride details!",

complete_all_rental_fields:
  "Plis pulimap olgeta rental details na makim pickup long map!",
pickup: "Hap Kisim",
dropoff: "Hap Lusim",
      install_global:
  "Global Transport na Marketplace Platform",

install_services:
  "Ol Sevis i Stap",

install_button:
  "Installim KinaTrip App",

app_screenshots:
  "Ol Screenshot bilong App",

taxi_booking:
  "🚕 Teksi Booking",

bus_transport:
  "🚌 Bas Transport",

motorbike:
  "🏍 Motorbike",

boat_transport:
  "🚤 Bot Transport",

delivery_services:
  "📦 Delivery Sevis",

rental_cars:
  "🚗 Kar bilong Rent",

copyright:
  "© 2026 KinaTrip Technologies Ltd. Olgeta rait i stap.",
      back_to_map: "⬅ Go Bek Long Map",
enter_fare: "Putim Fea",
click_pickup_map:
  "📍 Klikim map long makim Pickup",

click_dropoff_map:
  "🏁 Klikim map long makim ples bilong go",

pickup_placeholder:
  "📍 Pickup ples o Klikim Map",

dropoff_placeholder:
  "🏁 Destination ples o Klikim Map",

back_to_menu: "⬅ Go Bek Long Menyu",

select_date: "📅 Makim De",
select_time: "⏰ Makim Taim",

online: "Online",
offline: "Offline",

search_location: "Painim ples...",

driver_arriving: "Draiva i kam",
ride_completed: "Raun i pinis",

payment_successful: "Peimen i go gut",
payment_failed: "Peimen i no go gut",

withdraw_success: "Withdraw i go gut",
withdraw_pending: "Withdraw i wet yet",



ready: "Redi",
locked: "Pas",
withdrawal_unlocked: "Withdraw i op nau",
needed_unlock: "moa bilong opim withdraw",
pending_withdrawals: "Pending Withdrawals",
total_spent: "Olgeta mani lus",
total_saved: "Olgeta mani seiv",
withdrawn: "Withdraw pinis",
request_withdrawal: "Askim Withdraw",
wallet_transactions: "Wallet Transactions",
withdrawal_request: "Withdraw Askim",
ride_savings: "Ride Savings",
no_transactions: "No gat transactions yet",
processing: "I wok...",
enter_account: "Fon o Account Namba",
enter_amount: "Putim amount",
saved: "Seiv",
reply: "Bekim",
reply_comment: "Raitim bekim...",
recent_drivers: "Ol recent draiva",
no_recent_drivers: "No gat recent draiva",
create_post: "Mekim Post",
write_caption: "Raitim samting...",
pics: "Ol Piksa",
posting: "I wok long post...",
write_comment: "Raitim comment...",
send: "Salim",
weekly_spending: "Wiki Spending",
ride_log: "Ride Log",
no_rides: "No gat rides yet",



no_pickup_recorded: "No gat pickup i stap",
no_destination_recorded: "No gat ples bilong go i stap",
finance: "Finance",
expired: "Expair",

// TOK PISIN
driver: "Draiva",
now: "Nau",
minutes_ago: "minit igo pinis",
hours_ago: "aua igo pinis",
days_ago: "de igo pinis",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Risipt",
select_transaction_receipt: "Makim wanpela transaction daunbilo long lukim risipt.",
post_failed: "Post i no go gut",
monday: "Mande",
tuesday: "Tusde",
wednesday: "Wenesde",
thursday: "Tosde",
friday: "Fraide",
saturday: "Sarere",
sunday: "Sande",
feed: "Feed",
live: "Laiv",
recent: "Nupela",
total_rides: "Olgeta Rait",
completed: "Pinis",
dropoff: "Drop-off",
not_logged: "No gat rekod",
no_history: "No gat histori",
ride_history_dashboard: "Ride Histori Dashboard",
weekly_revenue: "Wiki Revenue",
total_revenue: "Olgeta Revenue",
search_passenger_location_phone: "Painim pasindia, hap o fon...",
all: "Olgeta",
accepted: "Kisim",
export: "Export",
receipts: "Ol Risipt",
no_phone: "No gat fon",
no_ride_history: "No gat ride histori yet.",
whats_happening: "Wanem i wok long kamap long KinaHub?",
video_selected: "Video i makim",
image_selected: "Piksa i makim",
remove: "Rausim",
pictures: "Ol Piksa",
videos: "Ol Video",
mood: "Pilim",
post: "Post",
public: "Publik",
likes: "laikim",
comments: "comments",
shares: "shares",
like: "Laikim",
comment: "Toktok",
share: "Serim",
post_link_copied: "Post link i copy pinis",
write_comment: "Raitim comment...",
private_account_section: "Dispela hap em private account.",
kinatrip_finance_wallet: "KinaTrip Finance Wallet",
lifetime_gross_earnings: "Olgeta Mani Kasim",
available_balance: "Mani I Stap",
today: "Tude",
this_week: "Dispela Wiki",
this_month: "Dispela Mun",
this_year: "Dispela Yia",
finance_actions: "Finance Actions",
transaction_records: "Transaction Records",
export_report: "Export Report",
tax_summary: "Tax Summary",
weekly_earnings: "Mande - Sande Earnings",
search_transaction: "Painim transaction, pasindia, fon...",
passenger_ride: "Passenger Ride",
gross: "Gross",
platform_fee: "Platform Fi",
net: "Net",
no_finance_transactions: "No gat finance transaction yet.",
kinahub_live_center: "KinaHub Live Center",
go_live: "Go Laiv",
upload_reel: "Upload Reel",
online_status: "Online Status",
safety_alert: "Safety Alert",
owner: "Owner",
viewer: "Viewer",
access: "Access",
visibility: "Visibility",
no_live_videos: "No gat live video o reel yet.",
live_link_copied: "Live link i copy pinis",




      assign_kinatrip_driver: "Makim KinaTrip Draiva",
buyer_confirm_received: "Baia i Confirm Kisim",
release_escrow_to_seller: "Lusim Eskro long Seller",

stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Cash",
seller_location: "Hap bilong Seller",
buyer_location: "Hap bilong Buyer",
user: "Yusa",
payment: "Peimen",
delivery: "Delivery",
status: "Status",
buyer: "Baia",
send: "Salim",
type_message: "Raitim tok...",
complete_all_fields: "Plis complete olgeta field.",
please_upload_receipt: "Plis uploadim receipt.",
cash_deposit_success: "Cash deposit i submit pinis gut.",



    service_taxi: "Teksi",
service_bus: "Bas",
service_rental: "Kar bilong rent",
service_boat: "Bot",
service_delivery: "Delivery trak",
service_motorbike: "Motorbike",

      direct_ride_requested: "Yu askim stret wanpela draiva!",
      ride_broadcasted: "Askim bilong raun i go long olgeta draiva!",
all_listings: "Olgeta Listings",
driver_listings: "Listings bilong Driver",
passenger_listings: "Listings bilong Pasinja",
business_listings: "Listings bilong Bisnis",
verified_sellers: "Ol Verified Seller",

seller_orders: "Ol Oda / Toktok bilong Seller",
accept_order: "Kisim Oda",
seller_review: "Seller i lukluk",
awaiting_payment: "Wet long Peimen",
escrow_holding: "Eskro i holim mani",
driver_assigned: "Draiva i makim",
delivered: "Delivered pinis",
escrow_released: "Eskro i lusim mani",
cash_deposit_verification: "Sekim Cash Deposit",
deposit_instruction:
  "Putim mani long approved KinaTrip account na salim details daunbilo.",
submit_cash_deposit: "Salim Cash Deposit",
loading_chat: "I wok long opim chat...",
payment_failed_start: "Peimen i no inap stat",


paypal_payment: "Pemant bilong PayPal", // Tok Pisin
category_electronics: "Elektronik",
category_fashion: "Klos na fashon",
category_home: "Haus na laip",
category_food: "Kaikai",
category_auto_parts: "Spia pat bilong kar",
category_stationery: "Buk na pepa samting",
category_services: "Sevis",
category_other: "Narapela",
ride_accepted_success: "Yu kisim raun gut!",
receipt_uploaded: "Receipt i upload pinis",
no_file_selected: "No file i makim yet",

market_item: "Item bilong maket",

market_buy_message: "Halo, mi laik baim dispela item:",
for_price: "long",


premium: "Premium",
days_label: "De",
select_payment_type: "Makim Peimen Kain",
cash_deposit: "Cash Deposit",
amount_paid: "Amaun Peim",
pay: "Peim",
securely_using: "long sef payment sistem",
stripe_payment: "Stripe — Intanesenel Peimen",
flutterwave_payment: "Flutterwave — Afrika",
xendit_payment: "Xendit — Esia",
activate_free_trial: "Aktivetim Fri Trial",
trial_active: "Trial I Stap",
trial_activated_success: "Trial Laisens I Aktiv Gut!",
submit_cash_payment: "Salim Cash Payment",
payment_screenshot_alt: "Piksa bilong Peimen",


license_trial: "Trial Laisens",
license_standard: "Standet Laisens",
license_silver: "Silva Laisens",
license_gold: "Gol Laisens",
free: "Fri",
fee: "Fi",
validity: "Taim bilong wok",
daily_limit: "Mak bilong ol pasindia long de",
passengers: "Pasindia",
unlimited_passengers: "Olgeta Pasindia",

select_license_plan: "Makim Laisens Plen",

online_card_payment: "Online Kad Peimen",
secure_payment_text:
  "Ol kad infomesen bilong yu i stap sef long ol certified payment gateway.",

cash_deposit_payment: "Han Peimen / Lokal Patna Peimen",

pay_through_partner:
  "Peim long approved KinaTrip Kantri Patna o lokal peimen ejent.",

country: "Kantri",
plan: "Plen",
amount: "Amaun",

full_name: "Ful Nem",
phone_number: "Fon Namba",

receipt_reference: "Risipt / Referens / Patna Kod",

upload_receipt:
  "Uploadim Risipt o Screenshot",

submit_payment: "Salim Peimen",

waiting_approval:
  "Peimen i go gut. Wet long admin approval.",

back_to_payment_type: "Go Bek Long Peimen Kain",




choose_file: "Makim Fail",

select_user_type: "Makim kain yusa",
passenger: "Pasindia",
driver_service_provider: "Draiva / Sevis Provayda",
already_have_account: "Yu gat account pinis? Login",
dont_have_account: "Yu no gat account? Signup",
login: "Login",
signup: "Signup",
email: "Email",
password: "Paswod",
confirm_password: "Confirmim Paswod",
phone: "Namba",
city: "Taun",
state_province: "Provins",
full_name: "Full nem",
business_service_name: "Nem bilong bisnis / sevis",
upload_profile_photo: "Uploadim Profil Piksa:",
please_wait: "⌛ Plis wet…",
select_service_default: "-- Makim Sevis --",
passwords_match: "✅ Paswod i wankain",
passwords_not_match: "❌ Paswod i no wankain",
strength: "Strong bilong paswod",


choose_file: "Makim Fail",
weak: "No Strong",
medium: "Liklik Strong",
strong: "Strong Tru",


escrow_active: "Eskro I Stap Aktif",
transport_provided_by_kinatrip: "KinaTrip i givim transport",
list_item_for_sale: "Putim Samting Bilong Salim",
what_are_you_selling_today: "Yu laik salim wanem tude?",
enter_price: "Putim prais",
select_category: "Makim kategori",
photo: "Piksa",
price: "Prais",
category: "Kategori",
post_item: "Putim Item",
posting: "I wok long putim...",
trending_items: "Ol Item i hot nau",
no_market_items_yet: "I no gat item yet.",
buy_now: "Baia Nau",
market_item: "Item bilong maket",
no_city: "I no gat taun",
no_country: "I no gat kantri",
escrow_description: "KINATRIP ESCROW: Mani bai stap gut inap long yu tok orait yu kisim item. Yu inap peim online, na ol draiva bilong mipela bai bringim i kam long yu.",


"Choose Driver": "Makim Draiva",
"With Driver": "Wantaim Draiva",
"Self Driver": "Yu yet yu draiva",
"Driver": "Draiva",


passenger_vehicles: "Kar bilong pasindia",
marine: "Bot",
cargo_transport: "Kago na transpot",
machinery_equipment: "Masin na ekwipmen",

vehicle_economy: "Ekonomi",
vehicle_sedan: "Sedan",
vehicle_suv: "SUV / 4WD",
vehicle_van: "Van",
vehicle_minibus: "Minibus",
vehicle_bus: "Bus / PMV",
vehicle_pickup: "Pickup",
vehicle_luxury: "Naispela kar",
vehicle_taxi: "Teksi",
vehicle_motorbike: "Moto",

vehicle_boat: "Bot / Dinghy",

vehicle_cargo_van: "Kago van",
vehicle_truck: "Trak",
vehicle_trailer: "Trela",

vehicle_forklift: "Forklift",
vehicle_excavator: "Ekskevetor",
vehicle_bulldozer: "Buldoza",
vehicle_grader: "Greida",
vehicle_loader: "Loda",
vehicle_roller: "Rola",
vehicle_crane: "Kren",
vehicle_tractor: "Trakta",
vehicle_generator: "Jenareta",

vehicle_other: "Narapela",


pickup_location: "Hap bilong pikap",
return_location: "Hap bilong bekim",
select_vehicle_type: "Makim kain kar",
offer_per_day: "Pe long wanpela de",
offer_per_day_label: "Pe / De",
total_will_be: "Olgeta mani bai em",
grand_total: "Olgeta Mani",
request_rental: "Askim long rentim",
optional_rental_note: "Opsenol: nidim draiva, AC i stap, kisim long moning, fuel i stap insait...",
pickup_required: "Pikap i mas stap",
return_required: "Bekim ples i mas stap",
select_vehicle: "Makim wanpela kar",
invalid_days: "Namba bilong ol de i no stret",
offer_per_day_required: "Pe bilong wanpela de i mas stap",
pickup_date_required: "De bilong pikap i mas stap",
pickup_time_required: "Taim bilong pikap i mas stap",
return_date_required: "De bilong bekim i mas stap",
return_time_required: "Taim bilong bekim i mas stap",
return_must_be_after_pickup: "Taim bilong bekim i mas bihain long pikap",
pickup: "Pikap",
return: "Bekim",
vehicle: "Kar",
days: "Ol De",
pickup_time: "Taim bilong Pikap",
return_time: "Taim bilong Bekim",
eta: "Taim bilong kamap",
minutes: "minit"

    }
  },

  fr: {
    translation: {
      logout: "Déconnexion", close: "Fermer", cancel: "Annuler", back: "Retour", booking: "Réservation", gps_denied: "Permission GPS refusée",
      wallet: "Portefeuille", history: "Historique", inbox: "Boîte de réception", ride_requests: "Demandes de trajet", whatsapp_support: "Support WhatsApp",
      menu: "Menu", wallet_balance: "Solde du portefeuille", pending_savings: "Économies en attente", last_ride_info: "Infos dernier trajet",
      select_pickup: "Cliquez sur la carte pour le départ", select_destination: "Cliquez pour la destination", distance: "Distance", fare: "Tarif", savings: "Économies",
      select_service: "Sélectionner un service", request_ride: "Demander un trajet", call: "Appeler", chat: "Discuter", accept_ride: "Accepter le trajet",
      new_request: "Nouvelle demande", your_passenger: "Votre passager", enter_key: "Entrer la clé", phone: "Téléphone", area: "Zone", map: "Carte", license: "Licence", support: "Assistance",
      kinamarket: "Marché Kina",
      whatsapp: "WhatsApp",
      accept_to_view: "Acceptez le trajet pour voir le contact et la zone",




signup_failed:
  "Échec de l'inscription. Veuillez réessayer.",

email_already_exists:
  "Cet e-mail est déjà enregistré.",

invalid_email:
  "Adresse e-mail invalide.",

weak_password_error:
  "Le mot de passe doit contenir au moins 6 caractères.",

network_error:
  "Erreur réseau. Vérifiez votre connexion Internet.",
complete_all_ride_fields:
  "Veuillez remplir tous les champs du trajet !",

complete_all_rental_fields:
  "Veuillez remplir tous les champs de location et sélectionner le point de départ sur la carte !",
pickup: "Ramassage",
dropoff: "Déposer",
      install_global:
  "Plateforme mondiale de transport et marketplace",

install_services:
  "Services disponibles",

install_button:
  "Installer l’application KinaTrip",

app_screenshots:
  "Captures d’écran de l’application",

taxi_booking:
  "🚕 Réservation de taxi",

bus_transport:
  "🚌 Transport en bus",

motorbike:
  "🏍 Moto",

boat_transport:
  "🚤 Transport maritime",

delivery_services:
  "📦 Services de livraison",

rental_cars:
  "🚗 Voitures de location",

copyright:
  "© 2026 KinaTrip Technologies Ltd. Tous droits réservés.",
      back_to_map: "⬅ Retour à la carte",
enter_fare: "Entrer le tarif",
click_pickup_map:
  "📍 Cliquez sur la carte pour le départ",

click_dropoff_map:
  "🏁 Cliquez sur la carte pour la destination",

pickup_placeholder:
  "📍 Lieu de départ ou cliquez sur la carte",

dropoff_placeholder:
  "🏁 Destination ou cliquez sur la carte",

back_to_menu: "⬅ Retour au menu",

select_date: "📅 Sélectionner une date",
select_time: "⏰ Sélectionner l'heure",

online: "En ligne",
offline: "Hors ligne",

search_location: "Rechercher un lieu...",

driver_arriving: "Le chauffeur arrive",
ride_completed: "Trajet terminé",

payment_successful: "Paiement réussi",
payment_failed: "Paiement échoué",

withdraw_success: "Retrait réussi",
withdraw_pending: "Retrait en attente",

ready: "Prêt",
locked: "Verrouillé",
withdrawal_unlocked: "Retrait débloqué",
needed_unlock: "encore nécessaire pour débloquer le retrait",
pending_withdrawals: "Retraits en attente",
total_spent: "Total dépensé",
total_saved: "Total économisé",
withdrawn: "Retiré",
request_withdrawal: "Demander un retrait",
wallet_transactions: "Transactions du portefeuille",
withdrawal_request: "Demande de retrait",
ride_savings: "Économies de trajet",
no_transactions: "Aucune transaction",
processing: "Traitement...",
enter_account: "Téléphone ou numéro de compte",
enter_amount: "Entrer le montant",
saved: "Économisé",
reply: "Répondre",
reply_comment: "Écrire une réponse...",
recent_drivers: "Chauffeurs récents",
no_recent_drivers: "Aucun chauffeur récent",
create_post: "Créer une publication",
write_caption: "Écrire quelque chose...",
pics: "Photos",
posting: "Publication...",
write_comment: "Écrire un commentaire...",
send: "Envoyer",
weekly_spending: "Dépenses hebdomadaires",
ride_log: "Historique des trajets",
no_rides: "Aucun trajet",


no_pickup_recorded: "Aucun lieu de départ enregistré",
no_destination_recorded: "Aucune destination enregistrée",
finance: "Finance",
expired: "Expiré",


// FRENCH
driver: "Chauffeur",
now: "Maintenant",
minutes_ago: "min passées",
hours_ago: "h passées",
days_ago: "jours passés",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Reçu",
select_transaction_receipt: "Sélectionnez une transaction ci-dessous pour voir le reçu.",
post_failed: "Échec de la publication",
monday: "Lundi",
tuesday: "Mardi",
wednesday: "Mercredi",
thursday: "Jeudi",
friday: "Vendredi",
saturday: "Samedi",
sunday: "Dimanche",
feed: "Flux",
live: "En direct",
recent: "Récent",
total_rides: "Total des trajets",
completed: "Terminé",
dropoff: "Destination",
not_logged: "Non enregistré",
no_history: "Aucun historique",
ride_history_dashboard: "Tableau de bord des trajets",
weekly_revenue: "Revenu hebdomadaire",
total_revenue: "Revenu total",
search_passenger_location_phone: "Rechercher passager, lieu, téléphone...",
all: "Tous",
accepted: "Accepté",
export: "Exporter",
receipts: "Reçus",
no_phone: "Pas de téléphone",
no_ride_history: "Aucun historique de trajet.",
whats_happening: "Que se passe-t-il sur KinaHub ?",
video_selected: "Vidéo sélectionnée",
image_selected: "Image sélectionnée",
remove: "Supprimer",
pictures: "Images",
videos: "Vidéos",
mood: "Humeur",
post: "Publier",
public: "Public",
likes: "mentions j’aime",
comments: "commentaires",
shares: "partages",
like: "J’aime",
comment: "Commenter",
share: "Partager",
post_link_copied: "Lien copié",
write_comment: "Écrire un commentaire...",
private_account_section: "Cette section est privée.",
kinatrip_finance_wallet: "Portefeuille KinaTrip",
lifetime_gross_earnings: "Gains bruts à vie",
available_balance: "Solde disponible",
today: "Aujourd’hui",
this_week: "Cette semaine",
this_month: "Ce mois",
this_year: "Cette année",
finance_actions: "Actions financières",
transaction_records: "Transactions",
export_report: "Exporter le rapport",
tax_summary: "Résumé fiscal",
weekly_earnings: "Gains du lundi au dimanche",
search_transaction: "Rechercher transaction, passager, téléphone...",
passenger_ride: "Trajet passager",
gross: "Brut",
platform_fee: "Frais plateforme",
net: "Net",
no_finance_transactions: "Aucune transaction financière.",
kinahub_live_center: "Centre Live KinaHub",
go_live: "Passer en direct",
upload_reel: "Télécharger Reel",
online_status: "Statut en ligne",
safety_alert: "Alerte sécurité",
owner: "Propriétaire",
viewer: "Spectateur",
access: "Accès",
visibility: "Visibilité",
no_live_videos: "Aucune vidéo en direct.",
live_link_copied: "Lien live copié",




assign_kinatrip_driver: "Attribuer un chauffeur KinaTrip",
buyer_confirm_received: "Acheteur a confirmé la réception",
release_escrow_to_seller: "Libérer l’escrow au vendeur",


     service_taxi: "Taxi",
service_bus: "Bus",
service_rental: "Location de voiture",
service_boat: "Bateau",
service_delivery: "Camion de livraison",
service_motorbike: "Moto",

      direct_ride_requested: "Trajet direct demandé !",
      ride_broadcasted: "Demande de trajet diffusée à tous les conducteurs !",


seller_orders: "Commandes / Discussions vendeur",
accept_order: "Accepter la commande",
seller_review: "Vérification du vendeur",
awaiting_payment: "En attente du paiement",
escrow_holding: "Fonds bloqués",
driver_assigned: "Chauffeur assigné",
delivered: "Livré",
escrow_released: "Fonds libérés",
cash_deposit_verification: "Vérification du dépôt en espèces",
deposit_instruction:
  "Déposez le paiement sur le compte approuvé KinaTrip et soumettez les détails ci-dessous.",
submit_cash_deposit: "Soumettre le dépôt",
loading_chat: "Chargement du chat...",
payment_failed_start: "Échec du démarrage du paiement",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Espèces",
seller_location: "Lieu du vendeur",
buyer_location: "Lieu de l’acheteur",
user: "Utilisateur",
payment: "Paiement",
delivery: "Livraison",
status: "Statut",
buyer: "Acheteur",
send: "Envoyer",
type_message: "Tapez votre message...",
complete_all_fields: "Veuillez remplir tous les champs.",
please_upload_receipt: "Veuillez télécharger le reçu.",
cash_deposit_success: "Dépôt envoyé avec succès.",


paypal_payment: "Paiement PayPal", // French
category_electronics: "Électronique",
category_fashion: "Mode",
category_home: "Maison et vie",
category_food: "Nourriture",
category_auto_parts: "Pièces auto",
category_stationery: "Papeterie",
category_services: "Services",
category_other: "Autre",
// French
ride_accepted_success: "Trajet accepté avec succès !",
receipt_uploaded: "Reçu téléchargé avec succès",
no_file_selected: "Aucun fichier sélectionné",


market_item: "Article du marché",

market_buy_message: "Bonjour, je veux acheter cet article :",
for_price: "pour",
all_listings: "Toutes les annonces",
driver_listings: "Annonces des chauffeurs",
passenger_listings: "Annonces des passagers",
business_listings: "Annonces des entreprises",
verified_sellers: "Vendeurs vérifiés",







premium: "Premium",
days_label: "Jours",
select_payment_type: "Sélectionner le type de paiement",
cash_deposit: "Dépôt en espèces",
amount_paid: "Montant payé",
pay: "Payer",
securely_using: "en utilisant un système sécurisé",
stripe_payment: "Stripe — Paiements internationaux",
flutterwave_payment: "Flutterwave — Afrique",
xendit_payment: "Xendit — Asie",
activate_free_trial: "Activer l’essai gratuit",
trial_active: "Essai actif",
trial_activated_success: "Licence d’essai activée avec succès !",
submit_cash_payment: "Soumettre le paiement en espèces",
payment_screenshot_alt: "Capture d’écran du paiement",



license_trial: "Licence d’essai",
license_standard: "Licence Standard",
license_silver: "Licence Argent",
license_gold: "Licence Or",
// French
free: "Gratuit",
fee: "Frais",
validity: "Validité",
daily_limit: "Limite quotidienne",
passengers: "Passagers",
unlimited_passengers: "Passagers illimités",

select_license_plan: "Sélectionner un plan de licence",

online_card_payment: "Paiement par carte en ligne",
secure_payment_text:
  "Vos informations bancaires sont sécurisées par des passerelles certifiées.",

cash_deposit_payment: "Paiement manuel / partenaire local",

pay_through_partner:
  "Payez via votre partenaire KinaTrip approuvé ou agent local.",

country: "Pays",
plan: "Plan",
amount: "Montant",

full_name: "Nom complet",
phone_number: "Numéro de téléphone",

receipt_reference: "Reçu / Référence / Code partenaire",

upload_receipt:
  "Télécharger le reçu ou la capture d’écran",

submit_payment: "Soumettre le paiement",

waiting_approval:
  "Paiement soumis avec succès. En attente d’approbation.",

back_to_payment_type: "Retour au type de paiement",


select_user_type: "Sélectionner le type d'utilisateur",
passenger: "Passager",
driver_service_provider: "Chauffeur / Prestataire",
already_have_account: "Vous avez déjà un compte ? Connexion",
dont_have_account: "Vous n'avez pas de compte ? Inscription",
login: "Connexion",
signup: "Inscription",
email: "E-mail",
password: "Mot de passe",
confirm_password: "Confirmer le mot de passe",
phone: "Téléphone",
city: "Ville",
state_province: "État/Province",
full_name: "Nom complet",
business_service_name: "Nom du service / entreprise",
upload_profile_photo: "Télécharger une photo de profil :",
please_wait: "⌛ Veuillez patienter…",
select_service_default: "-- Sélectionner un service --",
passwords_match: "✅ Les mots de passe correspondent",
passwords_not_match: "❌ Les mots de passe ne correspondent pas",
strength: "Force",

choose_file: "Choisir un fichier",
weak: "Faible",
medium: "Moyen",
strong: "Fort",


escrow_description: "DÉPÔT KINATRIP : Les fonds sont conservés en sécurité jusqu’à ce que vous confirmiez la réception de votre article. Payez en ligne et nos chauffeurs livrent à votre porte.",
escrow_active: "Dépôt sécurisé actif",
transport_provided_by_kinatrip: "Transport fourni par KinaTrip",
list_item_for_sale: "Mettre un article en vente",
what_are_you_selling_today: "Que vendez-vous aujourd’hui ?",
enter_price: "Entrer le prix",
select_category: "Sélectionner une catégorie",
photo: "Photo",
price: "Prix",
category: "Catégorie",
post_item: "Publier l’article",
posting: "Publication...",
trending_items: "Articles tendance",
no_market_items_yet: "Aucun article pour le moment.",
buy_now: "Acheter maintenant",
market_item: "Article du marché",
no_city: "Pas de ville",
no_country: "Pas de pays",



"Choose Driver": "Choisir un chauffeur",
"With Driver": "Avec chauffeur",
"Self Driver": "Sans chauffeur",
"Driver": "Chauffeur",

     passenger_vehicles: "Véhicules passagers",
marine: "Maritime",
cargo_transport: "Cargo et transport",
machinery_equipment: "Machines et équipements",

vehicle_economy: "Économique",
vehicle_sedan: "Berline",
vehicle_suv: "SUV / 4x4",
vehicle_van: "Fourgonnette",
vehicle_minibus: "Minibus",
vehicle_bus: "Bus",
vehicle_pickup: "Pick-up",
vehicle_luxury: "Luxe",
vehicle_taxi: "Taxi",
vehicle_motorbike: "Moto",

vehicle_boat: "Bateau / Pirogue",

vehicle_cargo_van: "Fourgon cargo",
vehicle_truck: "Camion",
vehicle_trailer: "Remorque",

vehicle_forklift: "Chariot élévateur",
vehicle_excavator: "Excavatrice",
vehicle_bulldozer: "Bulldozer",
vehicle_grader: "Niveleuse",
vehicle_loader: "Chargeuse",
vehicle_roller: "Rouleau compresseur",
vehicle_crane: "Grue",
vehicle_tractor: "Tracteur",
vehicle_generator: "Générateur",

vehicle_other: "Autre",


pickup_location: "Lieu de prise en charge",
return_location: "Lieu de retour",
select_vehicle_type: "Sélectionner le type de véhicule",
offer_per_day: "Offre par jour",
offer_per_day_label: "Offre / Jour",
total_will_be: "Le total sera",
grand_total: "Total général",
request_rental: "Demander une location",
optional_rental_note: "Optionnel : chauffeur nécessaire, climatisation requise, prise en charge tôt, carburant inclus...",

pickup_required: "Lieu de prise en charge requis",
return_required: "Lieu de retour requis",
select_vehicle: "Sélectionnez un véhicule",
invalid_days: "Nombre de jours invalide",
offer_per_day_required: "L’offre par jour est requise",
pickup_date_required: "Date de prise en charge requise",
pickup_time_required: "Heure de prise en charge requise",
return_date_required: "Date de retour requise",
return_time_required: "Heure de retour requise",
return_must_be_after_pickup: "Le retour doit être après la prise en charge",

pickup: "Prise en charge",
return: "Retour",
vehicle: "Véhicule",
days: "Jours",
pickup_time: "Heure de prise en charge",
return_time: "Heure de retour",
eta: "Temps estimé",
minutes: "min"

    }
  },

  es: {
    translation: {
      logout: "Cerrar sesión", close: "Cerrar", cancel: "Cancelar", back: "Volver", booking: "Reserva", gps_denied: "Permiso GPS denegado",
      wallet: "Billetera", history: "Historial", inbox: "Bandeja de entrada", ride_requests: "Peticiones de viaje", whatsapp_support: "Soporte WhatsApp",
      menu: "Menú", wallet_balance: "Saldo de la billetera", pending_savings: "Ahorros pendientes", last_ride_info: "Info del último viaje",
      select_pickup: "Haz clic para el punto de partida", select_destination: "Haz clic para el destino", distance: "Distancia", fare: "Tarifa", savings: "Ahorros",
      select_service: "Seleccionar servicio", request_ride: "Pedir viaje", call: "Llamar", chat: "Chatear", accept_ride: "Aceptar viaje",
      new_request: "Nueva solicitud", your_passenger: "Tu pasajero", enter_key: "Ingresar clave", phone: "Teléfono", area: "Área", map: "Mapa", license: "Licencia", support: "Soporte",
      kinamarket: "Mercado Kina",
      whatsapp: "WhatsApp",
      accept_to_view: "Acepte el viaje para ver el contacto y el área",



signup_failed:
  "Error al registrarse. Inténtalo de nuevo.",

email_already_exists:
  "Este correo ya está registrado.",

invalid_email:
  "Correo electrónico inválido.",

weak_password_error:
  "La contraseña debe tener al menos 6 caracteres.",

network_error:
  "Error de red. Verifique su conexión a Internet.",

complete_all_ride_fields:
  "¡Complete todos los campos del viaje!",

complete_all_rental_fields:
  "¡Complete todos los campos de alquiler y seleccione el punto de recogida en el mapa!",
pickup: "Recoger",
dropoff: "Bajar",
      install_global:
  "Plataforma global de transporte y marketplace",

install_services:
  "Servicios disponibles",

install_button:
  "Instalar la aplicación KinaTrip",

app_screenshots:
  "Capturas de pantalla de la aplicación",

taxi_booking:
  "🚕 Reserva de taxi",

bus_transport:
  "🚌 Transporte en autobús",

motorbike:
  "🏍 Motocicleta",

boat_transport:
  "🚤 Transporte marítimo",

delivery_services:
  "📦 Servicios de entrega",

rental_cars:
  "🚗 Coches de alquiler",

copyright:
  "© 2026 KinaTrip Technologies Ltd. Todos los derechos reservados.",
      back_to_map: "⬅ Volver al mapa",
enter_fare: "Ingrese la tarifa",
click_pickup_map:
  "📍 Haz clic en el mapa para recoger",

click_dropoff_map:
  "🏁 Haz clic en el mapa para destino",

pickup_placeholder:
  "📍 Lugar de recogida o clic en mapa",

dropoff_placeholder:
  "🏁 Destino o clic en mapa",

back_to_menu: "⬅ Volver al menú",

select_date: "📅 Seleccionar fecha",
select_time: "⏰ Seleccionar hora",

online: "En línea",
offline: "Desconectado",

search_location: "Buscar ubicación...",

driver_arriving: "Conductor llegando",
ride_completed: "Viaje completado",

payment_successful: "Pago exitoso",
payment_failed: "Pago fallido",

withdraw_success: "Retiro exitoso",
withdraw_pending: "Retiro pendiente",



ready: "Listo",
locked: "Bloqueado",
withdrawal_unlocked: "Retiro desbloqueado",
needed_unlock: "más necesario para desbloquear el retiro",
pending_withdrawals: "Retiros pendientes",
total_spent: "Total gastado",
total_saved: "Total ahorrado",
withdrawn: "Retirado",
request_withdrawal: "Solicitar retiro",
wallet_transactions: "Transacciones de billetera",
withdrawal_request: "Solicitud de retiro",
ride_savings: "Ahorros de viaje",
no_transactions: "Sin transacciones todavía",
processing: "Procesando...",
enter_account: "Número de teléfono o cuenta",
enter_amount: "Ingrese cantidad",
saved: "Ahorrado",
reply: "Responder",
reply_comment: "Escribe respuesta...",
recent_drivers: "Conductores recientes",
no_recent_drivers: "No hay conductores recientes",
create_post: "Crear publicación",
write_caption: "Escribe algo...",
pics: "Fotos",
posting: "Publicando...",
write_comment: "Escribir comentario...",
send: "Enviar",
weekly_spending: "Gasto semanal",
ride_log: "Registro de viajes",
no_rides: "Sin viajes todavía",


no_pickup_recorded: "No hay punto de recogida registrado",
no_destination_recorded: "No hay destino registrado",
finance: "Finanzas",
expired: "Expirado",


// SPANISH
driver: "Conductor",
now: "Ahora",
minutes_ago: "min atrás",
hours_ago: "h atrás",
days_ago: "días atrás",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Recibo",
select_transaction_receipt: "Seleccione una transacción abajo para ver el recibo.",
post_failed: "Error al publicar",
monday: "Lunes",
tuesday: "Martes",
wednesday: "Miércoles",
thursday: "Jueves",
friday: "Viernes",
saturday: "Sábado",
sunday: "Domingo",
feed: "Inicio",
live: "En vivo",
recent: "Reciente",
total_rides: "Total viajes",
completed: "Completado",
dropoff: "Destino",
not_logged: "No registrado",
no_history: "Sin historial",
ride_history_dashboard: "Panel de historial",
weekly_revenue: "Ingresos semanales",
total_revenue: "Ingresos totales",
search_passenger_location_phone: "Buscar pasajero, ubicación, teléfono...",
all: "Todos",
accepted: "Aceptado",
export: "Exportar",
receipts: "Recibos",
no_phone: "Sin teléfono",
no_ride_history: "Aún no hay historial.",
whats_happening: "¿Qué está pasando en KinaHub?",
video_selected: "Video seleccionado",
image_selected: "Imagen seleccionada",
remove: "Eliminar",
pictures: "Imágenes",
videos: "Videos",
mood: "Estado",
post: "Publicar",
public: "Público",
likes: "me gusta",
comments: "comentarios",
shares: "compartidos",
like: "Me gusta",
comment: "Comentario",
share: "Compartir",
post_link_copied: "Enlace copiado",
write_comment: "Escribir comentario...",
private_account_section: "Esta sección es privada.",
kinatrip_finance_wallet: "Billetera KinaTrip",
lifetime_gross_earnings: "Ganancias totales",
available_balance: "Saldo disponible",
today: "Hoy",
this_week: "Esta semana",
this_month: "Este mes",
this_year: "Este año",
finance_actions: "Acciones financieras",
transaction_records: "Transacciones",
export_report: "Exportar reporte",
tax_summary: "Resumen fiscal",
weekly_earnings: "Ganancias lunes-domingo",
search_transaction: "Buscar transacción, pasajero, teléfono...",
passenger_ride: "Viaje pasajero",
gross: "Bruto",
platform_fee: "Tarifa plataforma",
net: "Neto",
no_finance_transactions: "No hay transacciones financieras.",
kinahub_live_center: "Centro Live KinaHub",
go_live: "Transmitir",
upload_reel: "Subir Reel",
online_status: "Estado en línea",
safety_alert: "Alerta de seguridad",
owner: "Propietario",
viewer: "Espectador",
access: "Acceso",
visibility: "Visibilidad",
no_live_videos: "No hay videos en vivo.",
live_link_copied: "Enlace copiado",



paypal_payment: "Pago con PayPal", // Spanish
category_electronics: "Electrónica",
category_fashion: "Moda",
category_home: "Hogar y vida",
category_food: "Comida",
category_auto_parts: "Repuestos de auto",
category_stationery: "Papelería",
category_services: "Servicios",
category_other: "Otros",
// Spanish
ride_accepted_success: "¡Viaje aceptado correctamente!",
receipt_uploaded: "Recibo cargado correctamente",
no_file_selected: "Ningún archivo seleccionado",

market_item: "Artículo del mercado",

market_buy_message: "Hola, quiero comprar este artículo:",
for_price: "por",
all_listings: "Todos los anuncios",
driver_listings: "Anuncios de conductores",
passenger_listings: "Anuncios de pasajeros",
business_listings: "Anuncios de negocios",
verified_sellers: "Vendedores verificados",


assign_kinatrip_driver: "Asignar conductor KinaTrip",
buyer_confirm_received: "Comprador confirmó recepción",
release_escrow_to_seller: "Liberar escrow al vendedor",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Efectivo",
seller_location: "Ubicación del vendedor",
buyer_location: "Ubicación del comprador",
user: "Usuario",
payment: "Pago",
delivery: "Entrega",
status: "Estado",
buyer: "Comprador",
send: "Enviar",
type_message: "Escribe tu mensaje...",
complete_all_fields: "Complete todos los campos.",
please_upload_receipt: "Por favor suba el recibo.",
cash_deposit_success: "Depósito enviado correctamente.",


seller_orders: "Pedidos / Chats del vendedor",
accept_order: "Aceptar pedido",
seller_review: "Revisión del vendedor",
awaiting_payment: "Esperando pago",
escrow_holding: "Escrow retenido",
driver_assigned: "Conductor asignado",
delivered: "Entregado",
escrow_released: "Escrow liberado",
cash_deposit_verification: "Verificación de depósito en efectivo",
deposit_instruction:
  "Deposite el pago en la cuenta aprobada de KinaTrip y envíe los detalles abajo.",
submit_cash_deposit: "Enviar depósito",
loading_chat: "Cargando chat...",
payment_failed_start: "No se pudo iniciar el pago",

premium: "Premium",
days_label: "Días",
select_payment_type: "Seleccionar tipo de pago",
cash_deposit: "Depósito en efectivo",
amount_paid: "Monto pagado",
pay: "Pagar",
securely_using: "usando un sistema seguro",
stripe_payment: "Stripe — Pagos internacionales",
flutterwave_payment: "Flutterwave — África",
xendit_payment: "Xendit — Asia",
activate_free_trial: "Activar prueba gratuita",
trial_active: "Prueba activa",
trial_activated_success: "¡Licencia de prueba activada correctamente!",
submit_cash_payment: "Enviar pago en efectivo",
payment_screenshot_alt: "Captura del pago",




license_trial: "Licencia de prueba",
license_standard: "Licencia estándar",
license_silver: "Licencia plata",
license_gold: "Licencia oro",
// Spanish
free: "Gratis",
fee: "Tarifa",
validity: "Validez",
daily_limit: "Límite diario",
passengers: "Pasajeros",
unlimited_passengers: "Pasajeros ilimitados",

select_license_plan: "Seleccionar plan de licencia",

online_card_payment: "Pago con tarjeta en línea",
secure_payment_text:
  "Los datos de su tarjeta están protegidos por pasarelas certificadas.",

cash_deposit_payment: "Pago manual / socio local",

pay_through_partner:
  "Pague mediante su socio aprobado de KinaTrip o agente local.",

country: "País",
plan: "Plan",
amount: "Monto",

full_name: "Nombre completo",
phone_number: "Número de teléfono",

receipt_reference: "Recibo / Referencia / Código del socio",

upload_receipt:
  "Subir recibo o captura de pantalla",

submit_payment: "Enviar pago",

waiting_approval:
  "Pago enviado correctamente. Esperando aprobación.",

back_to_payment_type: "Volver al tipo de pago",



select_user_type: "Seleccionar tipo de usuario",
passenger: "Pasajero",
driver_service_provider: "Conductor / Proveedor de servicios",
already_have_account: "¿Ya tienes una cuenta? Iniciar sesión",
dont_have_account: "¿No tienes una cuenta? Registrarse",
login: "Iniciar sesión",
signup: "Registrarse",
email: "Correo electrónico",
password: "Contraseña",
confirm_password: "Confirmar contraseña",
phone: "Teléfono",
city: "Ciudad",
state_province: "Estado/Provincia",
full_name: "Nombre completo",
business_service_name: "Nombre del negocio / servicio",
upload_profile_photo: "Subir foto de perfil:",
please_wait: "⌛ Por favor espere…",
select_service_default: "-- Seleccionar servicio --",
passwords_match: "✅ Las contraseñas coinciden",
passwords_not_match: "❌ Las contraseñas no coinciden",
strength: "Fortaleza",


choose_file: "Elegir archivo",
weak: "Débil",
medium: "Medio",
strong: "Fuerte",

escrow_active: "Depósito en garantía activo",
transport_provided_by_kinatrip: "Transporte proporcionado por KinaTrip",
list_item_for_sale: "Publicar un artículo para vender",
what_are_you_selling_today: "¿Qué estás vendiendo hoy?",
enter_price: "Ingresar precio",
select_category: "Seleccionar categoría",
photo: "Foto",
price: "Precio",
category: "Categoría",
post_item: "Publicar artículo",
posting: "Publicando...",
trending_items: "Artículos en tendencia",
no_market_items_yet: "No hay artículos aún.",
buy_now: "Comprar ahora",
market_item: "Artículo del mercado",
no_city: "Sin ciudad",
no_country: "Sin país",
escrow_description: "ESCROW KINATRIP: Los fondos se mantienen seguros hasta que confirmes la recepción de tu artículo. Paga en línea y nuestros conductores lo entregan en tu puerta.",


      "Choose Driver": "Elegir conductor",
"With Driver": "Con conductor",
"Self Driver": "Sin conductor",
"Driver": "Conductor",



     service_taxi: "Taxi",
service_bus: "Autobús",
service_rental: "Alquiler de coche",
service_boat: "Barco",
service_delivery: "Camión de entrega",
service_motorbike: "Motocicleta",

      direct_ride_requested: "¡Viaje directo solicitado!",
      ride_broadcasted: "¡Solicitud de viaje enviada a todos los conductores!",


      passenger_vehicles: "Vehículos de pasajeros",
marine: "Marítimo",
cargo_transport: "Carga y transporte",
machinery_equipment: "Maquinaria y equipos",

vehicle_economy: "Económico",
vehicle_sedan: "Sedán",
vehicle_suv: "SUV / 4x4",
vehicle_van: "Furgoneta",
vehicle_minibus: "Minibús",
vehicle_bus: "Autobús",
vehicle_pickup: "Pickup",
vehicle_luxury: "Lujo",
vehicle_taxi: "Taxi",
vehicle_motorbike: "Motocicleta",

vehicle_boat: "Barco / Lancha",

vehicle_cargo_van: "Furgón de carga",
vehicle_truck: "Camión",
vehicle_trailer: "Remolque",

vehicle_forklift: "Montacargas",
vehicle_excavator: "Excavadora",
vehicle_bulldozer: "Bulldozer",
vehicle_grader: "Niveladora",
vehicle_loader: "Cargadora",
vehicle_roller: "Rodillo",
vehicle_crane: "Grúa",
vehicle_tractor: "Tractor",
vehicle_generator: "Generador",

vehicle_other: "Otro",


pickup_location: "Lugar de recogida",
return_location: "Lugar de devolución",
select_vehicle_type: "Seleccionar tipo de vehículo",
offer_per_day: "Oferta por día",
offer_per_day_label: "Oferta / Día",
total_will_be: "El total será",
grand_total: "Total general",
request_rental: "Solicitar alquiler",
optional_rental_note: "Opcional: se necesita conductor, aire acondicionado requerido, recogida temprana, combustible incluido...",

pickup_required: "Se requiere lugar de recogida",
return_required: "Se requiere lugar de devolución",
select_vehicle: "Seleccione un vehículo",
invalid_days: "Días no válidos",
offer_per_day_required: "Se requiere oferta por día",
pickup_date_required: "Se requiere fecha de recogida",
pickup_time_required: "Se requiere hora de recogida",
return_date_required: "Se requiere fecha de devolución",
return_time_required: "Se requiere hora de devolución",
return_must_be_after_pickup: "La devolución debe ser después de la recogida",

pickup: "Recogida",
return: "Devolución",
vehicle: "Vehículo",
days: "Días",
pickup_time: "Hora de recogida",
return_time: "Hora de devolución",
eta: "Tiempo estimado",
minutes: "min"
    }
  },

  pt: {
    translation: {
      logout: "Sair", close: "Fechar", cancel: "Cancelar", back: "Voltar", booking: "Reserva", gps_denied: "Permissão de GPS negada",
      wallet: "Carteira", history: "Histórico", inbox: "Caixa de entrada", ride_requests: "Solicitações de viagem", whatsapp_support: "Suporte WhatsApp",
      menu: "Menu", wallet_balance: "Saldo da Carteira", pending_savings: "Economia pendente", last_ride_info: "Informações da última viagem",
      select_pickup: "Clique no mapa para partida", select_destination: "Clique para destino", distance: "Distância", fare: "Tarifa", savings: "Economia",
      select_service: "Selecionar serviço", request_ride: "Solicitar viagem", call: "Ligar", chat: "Bate-papo", accept_ride: "Aceitar viagem",
      new_request: "Novo pedido", your_passenger: "Seu passageiro", enter_key: "Inserir chave", phone: "Telefone", area: "Área", map: "Mapa", license: "Licença", support: "Suporte",
      kinamarket: "Mercado Kina",
      whatsapp: "WhatsApp",
      accept_to_view: "Aceite a viagem para ver o contato e a área",





      signup_failed:
  "Falha no cadastro. Tente novamente.",

email_already_exists:
  "Este e-mail já está registrado.",

invalid_email:
  "Endereço de e-mail inválido.",

weak_password_error:
  "A senha deve ter pelo menos 6 caracteres.",

network_error:
  "Erro de rede. Verifique sua internet.",

complete_all_ride_fields:
  "Preencha todos os campos da viagem!",

complete_all_rental_fields:
  "Preencha todos os campos do aluguel e selecione o local de recolha no mapa!",
pickup: "Recolha",
dropoff: "Destino",
      install_global:
  "Plataforma global de transporte e marketplace",

install_services:
  "Serviços disponíveis",

install_button:
  "Instalar aplicativo KinaTrip",

app_screenshots:
  "Capturas de tela do aplicativo",

taxi_booking:
  "🚕 Reserva de táxi",

bus_transport:
  "🚌 Transporte de ônibus",

motorbike:
  "🏍 Motocicleta",

boat_transport:
  "🚤 Transporte marítimo",

delivery_services:
  "📦 Serviços de entrega",

rental_cars:
  "🚗 Carros para aluguel",

copyright:
  "© 2026 KinaTrip Technologies Ltd. Todos os direitos reservados.",
      back_to_map: "⬅ Voltar ao mapa",
enter_fare: "Digite a tarifa",
click_pickup_map:
  "📍 Clique no mapa para selecionar coleta",

click_dropoff_map:
  "🏁 Clique no mapa para selecionar destino",

pickup_placeholder:
  "📍 Local de coleta ou clique no mapa",

dropoff_placeholder:
  "🏁 Destino ou clique no mapa",

back_to_menu: "⬅ Voltar ao menu",

select_date: "📅 Selecionar data",
select_time: "⏰ Selecionar hora",

online: "Online",
offline: "Offline",

search_location: "Pesquisar localização...",

driver_arriving: "Motorista chegando",
ride_completed: "Viagem concluída",

payment_successful: "Pagamento realizado",
payment_failed: "Falha no pagamento",

withdraw_success: "Saque realizado",
withdraw_pending: "Saque pendente",




      ready: "Pronto",
locked: "Bloqueado",
withdrawal_unlocked: "Saque desbloqueado",
needed_unlock: "necessário para desbloquear saque",
pending_withdrawals: "Saques pendentes",
total_spent: "Total gasto",
total_saved: "Total economizado",
withdrawn: "Retirado",
request_withdrawal: "Solicitar saque",
wallet_transactions: "Transações da carteira",
withdrawal_request: "Solicitação de saque",
ride_savings: "Economias de viagem",
no_transactions: "Nenhuma transação ainda",
processing: "Processando...",
enter_account: "Telefone ou número da conta",
enter_amount: "Digite o valor",
saved: "Economizado",
reply: "Responder",
reply_comment: "Escreva resposta...",
recent_drivers: "Motoristas recentes",
no_recent_drivers: "Nenhum motorista recente",
create_post: "Criar postagem",
write_caption: "Escreva algo...",
pics: "Fotos",
posting: "Publicando...",
write_comment: "Escrever comentário...",
send: "Enviar",
weekly_spending: "Gastos semanais",
ride_log: "Histórico de viagens",
no_rides: "Nenhuma viagem ainda",


      no_pickup_recorded: "Nenhum local de recolha registrado",
no_destination_recorded: "Nenhum destino registrado",
finance: "Finanças",
expired: "Expirado",

// PORTUGUESE
driver: "Motorista",
now: "Agora",
minutes_ago: "min atrás",
hours_ago: "h atrás",
days_ago: "dias atrás",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Recibo",
select_transaction_receipt: "Selecione uma transação abaixo para ver o recibo.",
post_failed: "Falha na publicação",
monday: "Segunda-feira",
tuesday: "Terça-feira",
wednesday: "Quarta-feira",
thursday: "Quinta-feira",
friday: "Sexta-feira",
saturday: "Sábado",
sunday: "Domingo",
feed: "Feed",
live: "Ao vivo",
recent: "Recente",
total_rides: "Total de viagens",
completed: "Concluído",
dropoff: "Destino",
not_logged: "Não registrado",
no_history: "Sem histórico",
ride_history_dashboard: "Painel de Histórico",
weekly_revenue: "Receita semanal",
total_revenue: "Receita total",
search_passenger_location_phone: "Pesquisar passageiro, localização, telefone...",
all: "Todos",
accepted: "Aceito",
export: "Exportar",
receipts: "Recibos",
no_phone: "Sem telefone",
no_ride_history: "Nenhum histórico ainda.",
whats_happening: "O que está acontecendo no KinaHub?",
video_selected: "Vídeo selecionado",
image_selected: "Imagem selecionada",
remove: "Remover",
pictures: "Imagens",
videos: "Vídeos",
mood: "Humor",
post: "Postar",
public: "Público",
likes: "curtidas",
comments: "comentários",
shares: "compartilhamentos",
like: "Curtir",
comment: "Comentar",
share: "Compartilhar",
post_link_copied: "Link copiado",
write_comment: "Escreva um comentário...",
private_account_section: "Esta é uma seção privada.",
kinatrip_finance_wallet: "Carteira Financeira KinaTrip",
lifetime_gross_earnings: "Ganhos Totais",
available_balance: "Saldo disponível",
today: "Hoje",
this_week: "Esta semana",
this_month: "Este mês",
this_year: "Este ano",
finance_actions: "Ações Financeiras",
transaction_records: "Registros de Transações",
export_report: "Exportar Relatório",
tax_summary: "Resumo Fiscal",
weekly_earnings: "Ganhos de Segunda a Domingo",
search_transaction: "Pesquisar transação, passageiro, telefone...",
passenger_ride: "Viagem de Passageiro",
gross: "Bruto",
platform_fee: "Taxa da Plataforma",
net: "Líquido",
no_finance_transactions: "Nenhuma transação financeira.",
kinahub_live_center: "Centro Live KinaHub",
go_live: "Entrar ao Vivo",
upload_reel: "Enviar Reel",
online_status: "Status Online",
safety_alert: "Alerta de Segurança",
owner: "Proprietário",
viewer: "Visualizador",
access: "Acesso",
visibility: "Visibilidade",
no_live_videos: "Nenhum vídeo ao vivo.",
live_link_copied: "Link copiado",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Dinheiro",
seller_location: "Local do vendedor",
buyer_location: "Local do comprador",
user: "Usuário",
payment: "Pagamento",
delivery: "Entrega",
status: "Status",
buyer: "Comprador",
send: "Enviar",
type_message: "Digite sua mensagem...",
complete_all_fields: "Preencha todos os campos.",
please_upload_receipt: "Envie o recibo.",
cash_deposit_success: "Depósito enviado com sucesso.",


assign_kinatrip_driver: "Atribuir motorista KinaTrip",
buyer_confirm_received: "Comprador confirmou recebimento",
release_escrow_to_seller: "Liberar escrow para o vendedor",

category_electronics: "Eletrônicos",
category_fashion: "Moda",
category_home: "Casa e vida",
category_food: "Comida",
category_auto_parts: "Peças automotivas",
category_stationery: "Papelaria",
category_services: "Serviços",
category_other: "Outro",
// Portuguese
ride_accepted_success: "Viagem aceita com sucesso!",
receipt_uploaded: "Recibo enviado com sucesso",
no_file_selected: "Nenhum arquivo selecionado",
paypal_payment: "Pagamento PayPal", // Portuguese


market_item: "Item do mercado",

market_buy_message: "Olá, quero comprar este item:",
for_price: "por",
all_listings: "Todos os anúncios",
driver_listings: "Anúncios de motoristas",
passenger_listings: "Anúncios de passageiros",
business_listings: "Anúncios comerciais",
verified_sellers: "Vendedores verificados",


seller_orders: "Pedidos / Chats do vendedor",
accept_order: "Aceitar pedido",
seller_review: "Revisão do vendedor",
awaiting_payment: "Aguardando pagamento",
escrow_holding: "Escrow retido",
driver_assigned: "Motorista atribuído",
delivered: "Entregue",
escrow_released: "Escrow liberado",
cash_deposit_verification: "Verificação de depósito em dinheiro",
deposit_instruction:
  "Deposite o pagamento na conta aprovada da KinaTrip e envie os detalhes abaixo.",
submit_cash_deposit: "Enviar depósito",
loading_chat: "Carregando chat...",
payment_failed_start: "Falha ao iniciar pagamento",



premium: "Premium",
days_label: "Dias",
select_payment_type: "Selecionar tipo de pagamento",
cash_deposit: "Depósito em dinheiro",
amount_paid: "Valor pago",
pay: "Pagar",
securely_using: "usando sistema seguro",
stripe_payment: "Stripe — Pagamentos internacionais",
flutterwave_payment: "Flutterwave — África",
xendit_payment: "Xendit — Ásia",
activate_free_trial: "Ativar teste grátis",
trial_active: "Teste ativo",
trial_activated_success: "Licença de teste ativada com sucesso!",
submit_cash_payment: "Enviar pagamento em dinheiro",
payment_screenshot_alt: "Captura do pagamento",


license_trial: "Licença de teste",
license_standard: "Licença padrão",
license_silver: "Licença prata",
license_gold: "Licença ouro",
// Portuguese
free: "Grátis",
fee: "Taxa",
validity: "Validade",
daily_limit: "Limite diário",
passengers: "Passageiros",
unlimited_passengers: "Passageiros ilimitados",

select_license_plan: "Selecionar plano de licença",

online_card_payment: "Pagamento online com cartão",
secure_payment_text:
  "Os dados do seu cartão são protegidos por gateways certificados.",

cash_deposit_payment: "Pagamento manual / parceiro local",

pay_through_partner:
  "Pague através do parceiro KinaTrip aprovado ou agente local.",

country: "País",
plan: "Plano",
amount: "Valor",

full_name: "Nome completo",
phone_number: "Número de telefone",

receipt_reference: "Recibo / Referência / Código do parceiro",

upload_receipt:
  "Enviar recibo ou captura de tela",

submit_payment: "Enviar pagamento",

waiting_approval:
  "Pagamento enviado com sucesso. Aguardando aprovação.",

back_to_payment_type: "Voltar ao tipo de pagamento",


select_user_type: "Selecionar tipo de usuário",
passenger: "Passageiro",
driver_service_provider: "Motorista / Prestador de serviço",
already_have_account: "Já tem uma conta? Entrar",
dont_have_account: "Não tem uma conta? Registrar-se",
login: "Entrar",
signup: "Registrar-se",
email: "E-mail",
password: "Senha",
confirm_password: "Confirmar senha",
phone: "Telefone",
city: "Cidade",
state_province: "Estado/Província",
full_name: "Nome completo",
business_service_name: "Nome do negócio / serviço",
upload_profile_photo: "Enviar foto de perfil:",
please_wait: "⌛ Aguarde…",
select_service_default: "-- Selecionar serviço --",
passwords_match: "✅ As senhas coincidem",
passwords_not_match: "❌ As senhas não coincidem",
strength: "Força",

choose_file: "Escolher arquivo",
weak: "Fraca",
medium: "Média",
strong: "Forte",

escrow_active: "Custódia ativa",
transport_provided_by_kinatrip: "Transporte fornecido pela KinaTrip",
list_item_for_sale: "Anunciar um item para venda",
what_are_you_selling_today: "O que você está vendendo hoje?",
enter_price: "Inserir preço",
select_category: "Selecionar categoria",
photo: "Foto",
price: "Preço",
category: "Categoria",
post_item: "Publicar item",
posting: "Publicando...",
trending_items: "Itens em destaque",
no_market_items_yet: "Nenhum item ainda.",
buy_now: "Comprar agora",
market_item: "Item do mercado",
no_city: "Sem cidade",
no_country: "Sem país",
escrow_description: "ESCROW KINATRIP: Os fundos são mantidos com segurança até você confirmar o recebimento do item. Pague online e nossos motoristas entregam na sua porta.",



"Choose Driver": "Escolher motorista",
"With Driver": "Com motorista",
"Self Driver": "Sem motorista",
"Driver": "Motorista",

 service_taxi: "Táxi",
service_bus: "Ônibus",
service_rental: "Aluguel de carro",
service_boat: "Barco",
service_delivery: "Caminhão de entrega",
service_motorbike: "Motocicleta",

      direct_ride_requested: "Viagem direta solicitada!",
      ride_broadcasted: "Solicitação de viagem enviada para todos os motoristas!",


      passenger_vehicles: "Veículos de passageiros",
marine: "Marítimo",
cargo_transport: "Carga e transporte",
machinery_equipment: "Máquinas e equipamentos",

vehicle_economy: "Econômico",
vehicle_sedan: "Sedã",
vehicle_suv: "SUV / 4x4",
vehicle_van: "Van",
vehicle_minibus: "Minibus",
vehicle_bus: "Ônibus",
vehicle_pickup: "Pickup",
vehicle_luxury: "Luxo",
vehicle_taxi: "Táxi",
vehicle_motorbike: "Motocicleta",

vehicle_boat: "Barco / Lancha",

vehicle_cargo_van: "Van de carga",
vehicle_truck: "Caminhão",
vehicle_trailer: "Reboque",

vehicle_forklift: "Empilhadeira",
vehicle_excavator: "Escavadeira",
vehicle_bulldozer: "Bulldozer",
vehicle_grader: "Motoniveladora",
vehicle_loader: "Carregadeira",
vehicle_roller: "Rolo compactador",
vehicle_crane: "Guindaste",
vehicle_tractor: "Trator",
vehicle_generator: "Gerador",

vehicle_other: "Outro",


pickup_location: "Local de recolha",
return_location: "Local de devolução",
select_vehicle_type: "Selecionar tipo de veículo",
offer_per_day: "Oferta por dia",
offer_per_day_label: "Oferta / Dia",
total_will_be: "O total será",
grand_total: "Total geral",
request_rental: "Solicitar aluguel",
optional_rental_note: "Opcional: motorista necessário, ar-condicionado obrigatório, recolha cedo, combustível incluído...",

pickup_required: "Local de recolha é obrigatório",
return_required: "Local de devolução é obrigatório",
select_vehicle: "Selecione um veículo",
invalid_days: "Dias inválidos",
offer_per_day_required: "Oferta por dia é obrigatória",
pickup_date_required: "Data de recolha é obrigatória",
pickup_time_required: "Hora de recolha é obrigatória",
return_date_required: "Data de devolução é obrigatória",
return_time_required: "Hora de devolução é obrigatória",
return_must_be_after_pickup: "A devolução deve ser depois da recolha",

pickup: "Recolha",
return: "Devolução",
vehicle: "Veículo",
days: "Dias",
pickup_time: "Hora de recolha",
return_time: "Hora de devolução",
eta: "Tempo estimado",
minutes: "min"
    }
  },

  zh: {
    translation: {
      logout: "登出", close: "关闭", cancel: "取消", back: "返回", booking: "预订", gps_denied: "GPS权限被拒绝",
      wallet: "钱包", history: "历史记录", inbox: "收件箱", ride_requests: "乘车请求", whatsapp_support: "WhatsApp 支持",
      menu: "菜单", wallet_balance: "钱包余额", pending_savings: "待处理的储蓄", last_ride_info: "上次行程信息",
      select_pickup: "在地图上点击选择上车地点", select_destination: "在地图上点击选择目的地", distance: "距离", fare: "车费", savings: "节省",
      select_service: "选择服务", request_ride: "请求乘车", call: "呼叫", chat: "聊天", accept_ride: "接受行程",
      new_request: "新请求", your_passenger: "您的乘客", enter_key: "输入产品密钥", phone: "电话", area: "区域", map: "地图", license: "执照", support: "支持",
      kinamarket: "Kina市场",
      whatsapp: "WhatsApp",
      accept_to_view: "接受行程以查看联系方式和区域详情",



signup_failed:
  "注册失败，请重试。",

email_already_exists:
  "该邮箱已被注册。",

invalid_email:
  "无效的电子邮箱地址。",

weak_password_error:
  "密码至少需要6个字符。",

network_error:
  "网络错误，请检查您的网络连接。",
complete_all_ride_fields:
  "请填写所有行程信息！",

complete_all_rental_fields:
  "请填写所有租赁信息并在地图上选择上车地点！",
pickup: "上车点",
dropoff: "下车点",
      install_global: "全球交通与市场平台",

install_services: "可用服务",

install_button: "安装 KinaTrip 应用",

app_screenshots: "应用截图",

taxi_booking: "🚕 出租车预订",
bus_transport: "🚌 巴士运输",
motorbike: "🏍 摩托车",
boat_transport: "🚤 船只运输",
delivery_services: "📦 配送服务",
rental_cars: "🚗 租车服务",

copyright:
  "© 2026 KinaTrip Technologies Ltd. 版权所有。",
      back_to_map: "⬅ 返回地图",
enter_fare: "输入车费",
click_pickup_map:
  "📍 点击地图选择上车地点",

click_dropoff_map:
  "🏁 点击地图选择目的地",

pickup_placeholder:
  "📍 输入上车地点或点击地图",

dropoff_placeholder:
  "🏁 输入目的地或点击地图",

back_to_menu: "⬅ 返回菜单",

select_date: "📅 选择日期",
select_time: "⏰ 选择时间",

online: "在线",
offline: "离线",

search_location: "搜索位置...",

driver_arriving: "司机即将到达",
ride_completed: "行程完成",

payment_successful: "支付成功",
payment_failed: "支付失败",

withdraw_success: "提现成功",
withdraw_pending: "提现处理中",



ready: "准备好",
locked: "已锁定",
withdrawal_unlocked: "提现已解锁",
needed_unlock: "还需要解锁提现",
pending_withdrawals: "待处理提现",
total_spent: "总支出",
total_saved: "总储蓄",
withdrawn: "已提现",
request_withdrawal: "申请提现",
wallet_transactions: "钱包交易",
withdrawal_request: "提现申请",
ride_savings: "行程储蓄",
no_transactions: "暂无交易",
processing: "处理中...",
enter_account: "手机号或账户号码",
enter_amount: "输入金额",
saved: "已保存",
reply: "回复",
reply_comment: "写回复...",
recent_drivers: "最近司机",
no_recent_drivers: "暂无最近司机",
create_post: "创建帖子",
write_caption: "写点什么...",
pics: "图片",
posting: "发布中...",
write_comment: "写评论...",
send: "发送",
weekly_spending: "每周支出",
ride_log: "乘车记录",
no_rides: "暂无行程",


    no_pickup_recorded: "没有记录上车地点",
no_destination_recorded: "没有记录下车地点",  
finance: "财务",
expired: "已过期",


// CHINESE
driver: "司机",
now: "现在",
minutes_ago: "分钟前",
hours_ago: "小时前",
days_ago: "天前",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "收据",
select_transaction_receipt: "请选择下方交易查看收据。",
post_failed: "发布失败",
monday: "星期一",
tuesday: "星期二",
wednesday: "星期三",
thursday: "星期四",
friday: "星期五",
saturday: "星期六",
sunday: "星期日",
feed: "动态",
live: "直播",
recent: "最近",
total_rides: "总行程",
completed: "已完成",
dropoff: "下车地点",
not_logged: "未记录",
no_history: "暂无历史",
ride_history_dashboard: "行程历史面板",
weekly_revenue: "每周收入",
total_revenue: "总收入",
search_passenger_location_phone: "搜索乘客、地点、电话...",
all: "全部",
accepted: "已接受",
export: "导出",
receipts: "收据",
no_phone: "无电话",
no_ride_history: "暂无行程历史。",
whats_happening: "KinaHub 正在发生什么？",
video_selected: "已选择视频",
image_selected: "已选择图片",
remove: "移除",
pictures: "图片",
videos: "视频",
mood: "心情",
post: "发布",
public: "公开",
likes: "点赞",
comments: "评论",
shares: "分享",
like: "点赞",
comment: "评论",
share: "分享",
post_link_copied: "链接已复制",
write_comment: "写评论...",
private_account_section: "这是私人账户区域。",
kinatrip_finance_wallet: "KinaTrip 财务钱包",
lifetime_gross_earnings: "总收入",
available_balance: "可用余额",
today: "今天",
this_week: "本周",
this_month: "本月",
this_year: "今年",
finance_actions: "财务操作",
transaction_records: "交易记录",
export_report: "导出报告",
tax_summary: "税务摘要",
weekly_earnings: "周一至周日收入",
search_transaction: "搜索交易、乘客、电话...",
passenger_ride: "乘客行程",
gross: "总额",
platform_fee: "平台费用",
net: "净额",
no_finance_transactions: "暂无财务交易。",
kinahub_live_center: "KinaHub 直播中心",
go_live: "开始直播",
upload_reel: "上传短视频",
online_status: "在线状态",
safety_alert: "安全警报",
owner: "拥有者",
viewer: "观众",
access: "访问",
visibility: "可见性",
no_live_videos: "暂无直播视频。",
live_link_copied: "直播链接已复制",



    service_taxi: "出租车",
service_bus: "巴士",
service_rental: "租车",
service_boat: "船",
service_delivery: "送货卡车",
service_motorbike: "摩托车",

      direct_ride_requested: "已请求直达行程！",
      ride_broadcasted: "行程请求已广播给所有司机！",

paypal_payment: "PayPal支付", // Chinese
category_electronics: "电子产品",
category_fashion: "时尚",
category_home: "家居生活",
category_food: "食品",
category_auto_parts: "汽车配件",
category_stationery: "文具",
category_services: "服务",
category_other: "其他",
// Chinese
ride_accepted_success: "行程已成功接受！",
receipt_uploaded: "收据上传成功",
no_file_selected: "未选择文件",
market_item: "市场商品",

market_buy_message: "您好，我想购买这个商品：",
for_price: "价格",
all_listings: "所有商品",
driver_listings: "司机商品",
passenger_listings: "乘客商品",
business_listings: "商家商品",
verified_sellers: "认证卖家",


assign_kinatrip_driver: "分配 KinaTrip 司机",
buyer_confirm_received: "买家确认收到",
release_escrow_to_seller: "释放托管给卖家",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "现金",
seller_location: "卖家位置",
buyer_location: "买家位置",
user: "用户",
payment: "付款",
delivery: "配送",
status: "状态",
buyer: "买家",
send: "发送",
type_message: "输入您的消息...",
complete_all_fields: "请填写所有字段。",
please_upload_receipt: "请上传收据。",
cash_deposit_success: "现金存款提交成功。",




seller_orders: "卖家订单 / 聊天",
accept_order: "接受订单",
seller_review: "卖家审核",
awaiting_payment: "等待付款",
escrow_holding: "托管资金中",
driver_assigned: "已分配司机",
delivered: "已送达",
escrow_released: "托管已释放",
cash_deposit_verification: "现金存款验证",
deposit_instruction:
  "请将付款存入 KinaTrip 指定账户，并提交以下信息。",
submit_cash_deposit: "提交现金存款",
loading_chat: "聊天加载中...",
payment_failed_start: "付款启动失败",



premium: "高级版",
days_label: "天",
select_payment_type: "选择付款方式",
cash_deposit: "现金存款",
amount_paid: "支付金额",
pay: "支付",
securely_using: "使用安全支付系统",
stripe_payment: "Stripe — 国际支付",
flutterwave_payment: "Flutterwave — 非洲",
xendit_payment: "Xendit — 亚洲",
activate_free_trial: "激活免费试用",
trial_active: "试用已激活",
trial_activated_success: "试用许可证激活成功！",
submit_cash_payment: "提交现金付款",
payment_screenshot_alt: "付款截图",

license_trial: "试用许可证",
license_standard: "标准许可证",
license_silver: "白银许可证",
license_gold: "黄金许可证",
// Chinese
free: "免费",
fee: "费用",
validity: "有效期",
daily_limit: "每日限制",
passengers: "乘客",
unlimited_passengers: "无限乘客",

select_license_plan: "选择许可证计划",

online_card_payment: "在线银行卡支付",
secure_payment_text:
  "您的银行卡信息由认证支付网关安全保护。",

cash_deposit_payment: "人工 / 本地合作伙伴支付",

pay_through_partner:
  "请通过授权的 KinaTrip 国家合作伙伴或本地支付代理付款。",

country: "国家",
plan: "计划",
amount: "金额",

full_name: "全名",
phone_number: "电话号码",

receipt_reference: "收据 / 参考号 / 合作伙伴代码",

upload_receipt:
  "上传付款收据或截图",

submit_payment: "提交付款",

waiting_approval:
  "付款提交成功，等待管理员审核。",

back_to_payment_type: "返回付款方式",



choose_file: "选择文件",
weak: "弱",
medium: "中",
strong: "强",

select_user_type: "选择用户类型",
passenger: "乘客",
driver_service_provider: "司机 / 服务提供商",
already_have_account: "已有账户？登录",
dont_have_account: "没有账户？注册",
login: "登录",
signup: "注册",
email: "电子邮箱",
password: "密码",
confirm_password: "确认密码",
phone: "电话",
city: "城市",
state_province: "省/州",
full_name: "全名",
business_service_name: "公司 / 服务名称",
upload_profile_photo: "上传头像：",
please_wait: "⌛ 请稍候…",
select_service_default: "-- 选择服务 --",
passwords_match: "✅ 密码匹配",
passwords_not_match: "❌ 密码不匹配",
strength: "强度",



escrow_active: "托管已激活",
transport_provided_by_kinatrip: "由KinaTrip提供运输",
list_item_for_sale: "发布出售商品",
what_are_you_selling_today: "今天你要卖什么？",
enter_price: "输入价格",
select_category: "选择类别",
photo: "照片",
price: "价格",
category: "类别",
post_item: "发布商品",
posting: "发布中...",
trending_items: "热门商品",
no_market_items_yet: "暂无商品。",
buy_now: "立即购买",
market_item: "市场商品",
no_city: "无城市",
no_country: "无国家",
escrow_description: "KINATRIP托管：资金将被安全保管，直到您确认收到商品。在线支付，我们的司机会将商品送到您门口。",



      "Choose Driver": "选择司机",
"With Driver": "带司机",
"Self Driver": "自驾",
"Driver": "司机",

      passenger_vehicles: "乘用车辆",
marine: "水上运输",
cargo_transport: "货运与运输",
machinery_equipment: "机械设备",

vehicle_economy: "经济型",
vehicle_sedan: "轿车",
vehicle_suv: "SUV / 四驱",
vehicle_van: "面包车",
vehicle_minibus: "小巴",
vehicle_bus: "公交车",
vehicle_pickup: "皮卡",
vehicle_luxury: "豪华车",
vehicle_taxi: "出租车",
vehicle_motorbike: "摩托车",

vehicle_boat: "船 / 小艇",

vehicle_cargo_van: "货运面包车",
vehicle_truck: "卡车",
vehicle_trailer: "拖车",

vehicle_forklift: "叉车",
vehicle_excavator: "挖掘机",
vehicle_bulldozer: "推土机",
vehicle_grader: "平地机",
vehicle_loader: "装载机",
vehicle_roller: "压路机",
vehicle_crane: "起重机",
vehicle_tractor: "拖拉机",
vehicle_generator: "发电机",

vehicle_other: "其他",


pickup_location: "取车地点",
return_location: "还车地点",
select_vehicle_type: "选择车辆类型",
offer_per_day: "每日报价",
offer_per_day_label: "报价 / 天",
total_will_be: "总计将为",
grand_total: "总计",
request_rental: "请求租车",
optional_rental_note: "可选：需要司机、需要空调、提前取车、含燃油...",

pickup_required: "必须填写取车地点",
return_required: "必须填写还车地点",
select_vehicle: "请选择车辆",
invalid_days: "天数无效",
offer_per_day_required: "必须填写每日报价",
pickup_date_required: "必须填写取车日期",
pickup_time_required: "必须填写取车时间",
return_date_required: "必须填写还车日期",
return_time_required: "必须填写还车时间",
return_must_be_after_pickup: "还车时间必须晚于取车时间",

pickup: "取车",
return: "还车",
vehicle: "车辆",
days: "天数",
pickup_time: "取车时间",
return_time: "还车时间",
eta: "预计到达时间",
minutes: "分钟"
    }
  },

id: {
  translation: {

    driver: "Pengemudi",
    now: "Sekarang",
    total_rides: "Total Perjalanan",
    completed: "Selesai",
    weekly_revenue: "Pendapatan Mingguan",
    total_revenue: "Total Pendapatan",

  }
},

hi: {
  translation: {

    driver: "ड्राइवर",
    now: "अभी",
    total_rides: "कुल राइड",
    completed: "पूर्ण",
    weekly_revenue: "साप्ताहिक आय",
    total_revenue: "कुल आय",

  }
},

ru: {
  translation: {

    driver: "Водитель",
    now: "Сейчас",
    total_rides: "Всего поездок",
    completed: "Завершено",
    weekly_revenue: "Недельный доход",
    total_revenue: "Общий доход",

  }
},

ar: {
  translation: {

    driver: "السائق",
    now: "الآن",
    total_rides: "إجمالي الرحلات",
    completed: "مكتمل",
    weekly_revenue: "الإيرادات الأسبوعية",
    total_revenue: "إجمالي الإيرادات",


ru: {
  translation: {
    driver: "Водитель",
    total_rides: "Всего поездок",
    completed: "Завершено",
   
  }
},

ar: {
  translation: {
    driver: "السائق",
    total_rides: "إجمالي الرحلات",
    completed: "مكتمل",
  }
},

id: {
  translation: {
    driver: "Pengemudi",
    total_rides: "Total Perjalanan",
    completed: "Selesai",
    request_ride: "Pesan Perjalanan",
    wallet: "Dompet",
    history: "Riwayat",
    login: "Masuk",
    signup: "Daftar",
  }
},

hi: {
  translation: {
    driver: "ड्राइवर",
    total_rides: "कुल राइड",
    completed: "पूर्ण",
    request_ride: "राइड अनुरोध",
    wallet: "वॉलेट",
    history: "इतिहास",
    login: "लॉगिन",
    signup: "साइन अप",
   
  }
},

ru: {
  translation: {
    driver: "Водитель",
    total_rides: "Всего поездок",
    completed: "Завершено",
    request_ride: "Запрос поездки",
    wallet: "Кошелек",
    history: "История",
    login: "Войти",
    signup: "Регистрация",
  }
},

ar: {
  translation: {
    driver: "السائق",
    total_rides: "إجمالي الرحلات",
    completed: "مكتمل",
    request_ride: "طلب رحلة",
    wallet: "المحفظة",
    history: "السجل",
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
  }
},


id: {
  translation: {
    driver: "Pengemudi",
    total_rides: "Total Perjalanan",
    completed: "Selesai",
    request_ride: "Pesan Perjalanan",
    wallet: "Dompet",
    history: "Riwayat",
    login: "Masuk",
    signup: "Daftar",
    
  }
},

hi: {
  translation: {
    driver: "ड्राइवर",
    total_rides: "कुल राइड",
    completed: "पूर्ण",
    request_ride: "राइड अनुरोध",
    wallet: "वॉलेट",
    history: "इतिहास",
    login: "लॉगिन",
    signup: "साइन अप",
  }
},

ru: {
  translation: {
    driver: "Водитель",
    total_rides: "Всего поездок",
    completed: "Завершено",
    request_ride: "Запрос поездки",
    wallet: "Кошелек",
    history: "История",
    login: "Войти",
    signup: "Регистрация",
  }
},

ar: {
  translation: {
    driver: "السائق",
    total_rides: "إجمالي الرحلات",
    completed: "مكتمل",
    request_ride: "طلب رحلة",
    wallet: "المحفظة",
    history: "السجل",
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
  }
},



  }
},



  ar: {
    translation: {
      logout: "تسجيل خروج", close: "إغلاق", cancel: "إلغاء", back: "رجوع", booking: "حجز", gps_denied: "تم رفض إذن GPS",
      wallet: "محفظة", history: "السجل", inbox: "صندوق الوارد", ride_requests: "طلبات التوصيل", whatsapp_support: "دعم واتساب",
      menu: "القائمة", wallet_balance: "رصيد المحفظة", pending_savings: "المدخرات المعلقة", last_ride_info: "معلومات آخر رحلة",
      select_pickup: "انقر على الخريطة لتحديد نقطة الانطلاق", select_destination: "انقر لتحديد الوجهة", distance: "المسافة", fare: "الأجرة", savings: "المدخرات",
      select_service: "اختر الخدمة", request_ride: "اطلب رحلة", call: "اتصال", chat: "دردشة", accept_ride: "قبول الرحلة",
      new_request: "طلب جديد", your_passenger: "الراكب الخاص بك", enter_key: "أدخل مفتاح المنتج", phone: "الهاتف", area: "المنطقة", map: "الخريطة", license: "الرخصة", support: "الدعم",
      kinamarket: "سوق كينا",
      whatsapp: "واتساب",
      accept_to_view: "اقبل الرحلة لعرض تفاصيل جهة الاتصال والمنطقة",





      signup_failed:
  "فشل التسجيل. يرجى المحاولة مرة أخرى.",

email_already_exists:
  "هذا البريد الإلكتروني مسجل بالفعل.",

invalid_email:
  "عنوان البريد الإلكتروني غير صالح.",

weak_password_error:
  "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",

network_error:
  "خطأ في الشبكة. تحقق من اتصال الإنترنت.",
complete_all_ride_fields:
  "يرجى إكمال جميع معلومات الرحلة!",

complete_all_rental_fields:
  "يرجى إكمال جميع معلومات التأجير وتحديد نقطة الاستلام على الخريطة!",
pickup: "نقطة الاستلام",
dropoff: "نقطة النزول",
install_global: "منصة النقل والأسواق العالمية",

install_services: "الخدمات المتوفرة",

install_button: "تثبيت تطبيق KinaTrip",

app_screenshots: "لقطات شاشة التطبيق",

taxi_booking: "🚕 حجز سيارات الأجرة",
bus_transport: "🚌 النقل بالحافلات",
motorbike: "🏍 الدراجات النارية",
boat_transport: "🚤 النقل البحري",
delivery_services: "📦 خدمات التوصيل",
rental_cars: "🚗 تأجير السيارات",

copyright:
  "© 2026 KinaTrip Technologies Ltd. جميع الحقوق محفوظة.",
      back_to_map: "⬅ العودة إلى الخريطة",
enter_fare: "أدخل الأجرة",
click_pickup_map:
  "📍 اضغط على الخريطة لتحديد موقع الانطلاق",

click_dropoff_map:
  "🏁 اضغط على الخريطة لتحديد الوجهة",

pickup_placeholder:
  "📍 موقع الانطلاق أو اضغط على الخريطة",

dropoff_placeholder:
  "🏁 موقع الوجهة أو اضغط على الخريطة",

back_to_menu: "⬅ العودة إلى القائمة",

select_date: "📅 اختر التاريخ",
select_time: "⏰ اختر الوقت",

online: "متصل",
offline: "غير متصل",

search_location: "ابحث عن موقع...",

driver_arriving: "السائق في الطريق",
ride_completed: "اكتملت الرحلة",

payment_successful: "تم الدفع بنجاح",
payment_failed: "فشل الدفع",

withdraw_success: "تم السحب بنجاح",
withdraw_pending: "السحب قيد الانتظار",




   ready: "جاهز",
locked: "مقفل",
withdrawal_unlocked: "تم فتح السحب",
needed_unlock: "مطلوب المزيد لفتح السحب",
pending_withdrawals: "السحوبات المعلقة",
total_spent: "إجمالي المصروف",
total_saved: "إجمالي المدخرات",
withdrawn: "تم السحب",
request_withdrawal: "طلب سحب",
wallet_transactions: "معاملات المحفظة",
withdrawal_request: "طلب السحب",
ride_savings: "توفير الرحلات",
no_transactions: "لا توجد معاملات",
processing: "جارٍ المعالجة...",
enter_account: "رقم الهاتف أو الحساب",
enter_amount: "أدخل المبلغ",
saved: "تم التوفير",
reply: "رد",
reply_comment: "اكتب رد...",
recent_drivers: "السائقون الأخيرون",
no_recent_drivers: "لا يوجد سائقون حديثون",
create_post: "إنشاء منشور",
write_caption: "اكتب شيئًا...",
pics: "صور",
posting: "جارٍ النشر...",
write_comment: "اكتب تعليق...",
send: "إرسال",
weekly_spending: "الإنفاق الأسبوعي",
ride_log: "سجل الرحلات",
no_rides: "لا توجد رحلات",   



no_pickup_recorded: "لم يتم تسجيل موقع الاستلام",
no_destination_recorded: "لم يتم تسجيل الوجهة",
finance: "المالية",
expired: "منتهي الصلاحية",

// ARABIC
driver: "السائق",
now: "الآن",
minutes_ago: "دقائق مضت",
hours_ago: "ساعات مضت",
days_ago: "أيام مضت",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "إيصال",
select_transaction_receipt: "اختر معاملة أدناه لعرض الإيصال.",
post_failed: "فشل النشر",
monday: "الاثنين",
tuesday: "الثلاثاء",
wednesday: "الأربعاء",
thursday: "الخميس",
friday: "الجمعة",
saturday: "السبت",
sunday: "الأحد",
feed: "المنشورات",
live: "مباشر",
recent: "الأحدث",
total_rides: "إجمالي الرحلات",
completed: "مكتمل",
dropoff: "مكان النزول",
not_logged: "غير مسجل",
no_history: "لا يوجد سجل",
ride_history_dashboard: "لوحة سجل الرحلات",
weekly_revenue: "الإيرادات الأسبوعية",
total_revenue: "إجمالي الإيرادات",
search_passenger_location_phone: "ابحث عن راكب أو موقع أو هاتف...",
all: "الكل",
accepted: "تم القبول",
export: "تصدير",
receipts: "الإيصالات",
no_phone: "لا يوجد هاتف",
no_ride_history: "لا يوجد سجل رحلات.",
whats_happening: "ماذا يحدث على KinaHub؟",
video_selected: "تم اختيار فيديو",
image_selected: "تم اختيار صورة",
remove: "إزالة",
pictures: "صور",
videos: "فيديوهات",
mood: "الحالة",
post: "نشر",
public: "عام",
likes: "إعجابات",
comments: "تعليقات",
shares: "مشاركات",
like: "إعجاب",
comment: "تعليق",
share: "مشاركة",
post_link_copied: "تم نسخ الرابط",
write_comment: "اكتب تعليق...",
private_account_section: "هذا قسم حساب خاص.",
kinatrip_finance_wallet: "محفظة KinaTrip المالية",
lifetime_gross_earnings: "إجمالي الأرباح",
available_balance: "الرصيد المتاح",
today: "اليوم",
this_week: "هذا الأسبوع",
this_month: "هذا الشهر",
this_year: "هذا العام",
finance_actions: "الإجراءات المالية",
transaction_records: "سجلات المعاملات",
export_report: "تصدير التقرير",
tax_summary: "ملخص الضرائب",
weekly_earnings: "أرباح الإثنين - الأحد",
search_transaction: "ابحث عن معاملة أو راكب أو هاتف...",
passenger_ride: "رحلة راكب",
gross: "الإجمالي",
platform_fee: "رسوم المنصة",
net: "الصافي",
no_finance_transactions: "لا توجد معاملات مالية.",
kinahub_live_center: "مركز KinaHub المباشر",
go_live: "ابدأ البث",
upload_reel: "رفع Reel",
online_status: "الحالة أونلاين",
safety_alert: "تنبيه أمني",
owner: "المالك",
viewer: "المشاهد",
access: "الوصول",
visibility: "الرؤية",
no_live_videos: "لا توجد فيديوهات مباشرة.",
live_link_copied: "تم نسخ رابط البث",




    service_taxi: "تاكسي",
service_bus: "حافلة",
service_rental: "تأجير سيارات",
service_boat: "قارب",
service_delivery: "شاحنة توصيل",
service_motorbike: "دراجة نارية",

      direct_ride_requested: "تم طلب رحلة مباشرة!",
      ride_broadcasted: "تم إرسال طلب الرحلة إلى جميع السائقين!",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "نقداً",
seller_location: "موقع البائع",
buyer_location: "موقع المشتري",
user: "مستخدم",
payment: "الدفع",
delivery: "التوصيل",
status: "الحالة",
buyer: "المشتري",
send: "إرسال",
type_message: "اكتب رسالتك...",
complete_all_fields: "يرجى إكمال جميع الحقول.",
please_upload_receipt: "يرجى رفع الإيصال.",
cash_deposit_success: "تم إرسال الإيداع النقدي بنجاح.",


assign_kinatrip_driver: "تعيين سائق KinaTrip",
buyer_confirm_received: "أكد المشتري الاستلام",
release_escrow_to_seller: "تحرير الضمان للبائع",


paypal_payment: "دفع PayPal", // Arabic
category_electronics: "إلكترونيات",
category_fashion: "موضة",
category_home: "المنزل والحياة",
category_food: "طعام",
category_auto_parts: "قطع غيار السيارات",
category_stationery: "قرطاسية",
category_services: "خدمات",
category_other: "أخرى",
// Arabic
ride_accepted_success: "تم قبول الرحلة بنجاح!",
receipt_uploaded: "تم تحميل الإيصال بنجاح",
no_file_selected: "لم يتم اختيار ملف",

market_item: "عنصر السوق",

market_buy_message: "مرحبًا، أريد شراء هذا المنتج:",
for_price: "بسعر",
all_listings: "جميع الإعلانات",
driver_listings: "إعلانات السائقين",
passenger_listings: "إعلانات الركاب",
business_listings: "إعلانات الأعمال",
verified_sellers: "البائعون المعتمدون",




premium: "مميز",
days_label: "أيام",
select_payment_type: "اختر طريقة الدفع",
cash_deposit: "إيداع نقدي",
amount_paid: "المبلغ المدفوع",
pay: "ادفع",
securely_using: "باستخدام نظام دفع آمن",
stripe_payment: "Stripe — المدفوعات الدولية",
flutterwave_payment: "Flutterwave — أفريقيا",
xendit_payment: "Xendit — آسيا",
activate_free_trial: "تفعيل التجربة المجانية",
trial_active: "التجربة مفعلة",
trial_activated_success: "تم تفعيل الترخيص التجريبي بنجاح!",
submit_cash_payment: "إرسال الدفع النقدي",
payment_screenshot_alt: "لقطة شاشة الدفع",




license_trial: "رخصة تجريبية",
license_standard: "الرخصة القياسية",
license_silver: "الرخصة الفضية",
license_gold: "الرخصة الذهبية",

free: "مجاني",
fee: "الرسوم",
validity: "مدة الصلاحية",
daily_limit: "الحد اليومي",
passengers: "الركاب",


unlimited_passengers: "عدد غير محدود من الركاب",

select_license_plan: "اختر خطة الترخيص",

online_card_payment: "الدفع الإلكتروني بالبطاقة",

secure_payment_text:
  "يتم تأمين بيانات بطاقتك بواسطة بوابات دفع معتمدة.",

cash_deposit_payment: "دفع يدوي / شريك محلي",

pay_through_partner:
  "ادفع من خلال شريك KinaTrip المعتمد أو وكيل الدفع المحلي.",

country: "الدولة",
plan: "الخطة",
amount: "المبلغ",

phone_number: "رقم الهاتف",

receipt_reference:
  "الإيصال / المرجع / رمز الشريك",

upload_receipt:
  "تحميل إيصال الدفع أو لقطة الشاشة",

submit_payment: "إرسال الدفع",

waiting_approval:
  "تم إرسال الدفع بنجاح. في انتظار موافقة الإدارة.",

back_to_payment_type:
  "العودة إلى نوع الدفع",






select_user_type: "اختر نوع المستخدم",
passenger: "راكب",
driver_service_provider: "سائق / مزود خدمة",
already_have_account: "لديك حساب بالفعل؟ تسجيل الدخول",
dont_have_account: "ليس لديك حساب؟ إنشاء حساب",
login: "تسجيل الدخول",
signup: "إنشاء حساب",
email: "البريد الإلكتروني",
password: "كلمة المرور",
confirm_password: "تأكيد كلمة المرور",
phone: "الهاتف",
city: "المدينة",
state_province: "الولاية / المقاطعة",
full_name: "الاسم الكامل",
business_service_name: "اسم الشركة / الخدمة",
upload_profile_photo: "تحميل صورة الملف الشخصي:",
please_wait: "⌛ الرجاء الانتظار…",
select_service_default: "-- اختر الخدمة --",
passwords_match: "✅ كلمات المرور متطابقة",
passwords_not_match: "❌ كلمات المرور غير متطابقة",
strength: "القوة",

choose_file: "اختر ملف",
weak: "ضعيف",
medium: "متوسط",
strong: "قوي",


escrow_active: "الضمان نشط",
transport_provided_by_kinatrip: "النقل مقدم من KinaTrip",
list_item_for_sale: "عرض عنصر للبيع",
what_are_you_selling_today: "ماذا تبيع اليوم؟",
enter_price: "أدخل السعر",
select_category: "اختر الفئة",
photo: "صورة",
price: "السعر",
category: "الفئة",
post_item: "نشر العنصر",
posting: "جاري النشر...",
trending_items: "العناصر الشائعة",
no_market_items_yet: "لا توجد عناصر بعد.",
buy_now: "اشتر الآن",
market_item: "عنصر السوق",
no_city: "لا توجد مدينة",
no_country: "لا توجد دولة",
escrow_description: "ضمان KINATRIP: يتم الاحتفاظ بالأموال بأمان حتى تؤكد استلام العنصر. ادفع عبر الإنترنت وسيوصل السائقون الطلب إلى بابك.",



      "Choose Driver": "اختر سائق",
"With Driver": "مع سائق",
"Self Driver": "بدون سائق",
"Driver": "سائق",

      passenger_vehicles: "مركبات الركاب",
marine: "النقل البحري",
cargo_transport: "الشحن والنقل",
machinery_equipment: "الآلات والمعدات",

vehicle_economy: "اقتصادي",
vehicle_sedan: "سيدان",
vehicle_suv: "دفع رباعي",
vehicle_van: "فان",
vehicle_minibus: "حافلة صغيرة",
vehicle_bus: "حافلة",
vehicle_pickup: "بيك أب",
vehicle_luxury: "فاخر",
vehicle_taxi: "تاكسي",
vehicle_motorbike: "دراجة نارية",

vehicle_boat: "قارب",

vehicle_cargo_van: "فان شحن",
vehicle_truck: "شاحنة",
vehicle_trailer: "مقطورة",

vehicle_forklift: "رافعة شوكية",
vehicle_excavator: "حفارة",
vehicle_bulldozer: "جرافة",
vehicle_grader: "ممهدة",
vehicle_loader: "لودر",
vehicle_roller: "مدحلة",
vehicle_crane: "رافعة",
vehicle_tractor: "جرار",
vehicle_generator: "مولد",

vehicle_other: "أخرى",


pickup_location: "موقع الاستلام",
return_location: "موقع الإرجاع",
select_vehicle_type: "اختر نوع المركبة",
offer_per_day: "السعر لكل يوم",
offer_per_day_label: "السعر / اليوم",
total_will_be: "سيكون المجموع",
grand_total: "المجموع الكلي",
request_rental: "طلب استئجار",
optional_rental_note: "اختياري: مطلوب سائق، تكييف مطلوب، استلام مبكر، الوقود مشمول...",

pickup_required: "موقع الاستلام مطلوب",
return_required: "موقع الإرجاع مطلوب",
select_vehicle: "اختر مركبة",
invalid_days: "عدد الأيام غير صالح",
offer_per_day_required: "السعر لكل يوم مطلوب",
pickup_date_required: "تاريخ الاستلام مطلوب",
pickup_time_required: "وقت الاستلام مطلوب",
return_date_required: "تاريخ الإرجاع مطلوب",
return_time_required: "وقت الإرجاع مطلوب",
return_must_be_after_pickup: "يجب أن يكون الإرجاع بعد الاستلام",

pickup: "الاستلام",
return: "الإرجاع",
vehicle: "المركبة",
days: "الأيام",
pickup_time: "وقت الاستلام",
return_time: "وقت الإرجاع",
eta: "الوقت المتوقع",
minutes: "دقيقة"
    }
  },

  ru: {
    translation: {
      logout: "Выйти", close: "Закрыть", cancel: "Отмена", back: "Назад", booking: "Бронирование", gps_denied: "В доступе к GPS отказано",
      wallet: "Кошелек", history: "История", inbox: "Входящие", ride_requests: "Запросы на поездку", whatsapp_support: "Поддержка WhatsApp",
      menu: "Меню", wallet_balance: "Баланс кошелька", pending_savings: "Ожидаемые сбережения", last_ride_info: "Информация о последней поездке",
      select_pickup: "Нажмите на карту, чтобы выбрать место посадки", select_destination: "Нажмите для пункта назначения", distance: "Расстояние", fare: "Тариф", savings: "Сбережения",
      select_service: "Выберите сервис", request_ride: "Заказать поездку", call: "Позвонить", chat: "Чат", accept_ride: "Принять поездку",
      new_request: "Новый запрос", your_passenger: "Ваш пассажир", enter_key: "Введите ключ", phone: "Телефон", area: "Район", map: "Карта", license: "Лицензия", support: "Поддержка",
      kinamarket: "Рынок Kina",
      whatsapp: "WhatsApp",
      accept_to_view: "Примите поездку, чтобы увидеть контактные данные и район",


signup_failed:
  "Ошибка регистрации. Попробуйте снова.",

email_already_exists:
  "Этот адрес электронной почты уже зарегистрирован.",

invalid_email:
  "Неверный адрес электронной почты.",

weak_password_error:
  "Пароль должен содержать не менее 6 символов.",

network_error:
  "Ошибка сети. Проверьте интернет-соединение.",
complete_all_ride_fields:
  "Пожалуйста, заполните все поля поездки!",

complete_all_rental_fields:
  "Пожалуйста, заполните все поля аренды и выберите место посадки на карте!",
pickup: "Посадка",
dropoff: "Высадка",
install_global:
  "Глобальная транспортная и торговая платформа",

install_services:
  "Доступные услуги",

install_button:
  "Установить приложение KinaTrip",

app_screenshots:
  "Скриншоты приложения",

taxi_booking:
  "🚕 Заказ такси",

bus_transport:
  "🚌 Автобусный транспорт",

motorbike:
  "🏍 Мотоцикл",

boat_transport:
  "🚤 Водный транспорт",

delivery_services:
  "📦 Службы доставки",

rental_cars:
  "🚗 Аренда автомобилей",

copyright:
  "© 2026 KinaTrip Technologies Ltd. Все права защищены.",
      back_to_map: "⬅ Назад к карте",
click_pickup_map:
  "📍 Нажмите на карту, чтобы выбрать место посадки",

click_dropoff_map:
  "🏁 Нажмите на карту, чтобы выбрать пункт назначения",

select_service:
  "Выбрать услугу",

back_to_menu:
  "⬅ Назад в меню",

driver_accepted_ride:
  "🚗 Водитель принял вашу поездку",

ride_cancelled:
  "Поездка отменена",

ride_confirmed_success:
  "Поездка успешно подтверждена!",

click_pickup_location:
  "📍 Нажмите на карту, чтобы выбрать место посадки",

pickup_placeholder:
  "📍 Место посадки или нажмите на карту",

dropoff_placeholder:
  "🏁 Пункт назначения или нажмите на карту",

pickup_location:
  "📍 Место посадки",

dropoff_location:
  "🏁 Пункт назначения",



enter_fare: "Введите стоимость",
ready: "Готово",
locked: "Заблокировано",
withdrawal_unlocked: "Вывод разблокирован",
needed_unlock: "нужно больше для разблокировки вывода",
pending_withdrawals: "Ожидающие выводы",
total_spent: "Всего потрачено",
total_saved: "Всего сохранено",
withdrawn: "Выведено",
request_withdrawal: "Запросить вывод",
wallet_transactions: "Транзакции кошелька",
withdrawal_request: "Запрос на вывод",
ride_savings: "Сбережения поездок",
no_transactions: "Транзакций пока нет",
processing: "Обработка...",
enter_account: "Телефон или номер счета",
enter_amount: "Введите сумму",
saved: "Сохранено",
reply: "Ответить",
reply_comment: "Напишите ответ...",
recent_drivers: "Недавние водители",
no_recent_drivers: "Нет недавних водителей",
create_post: "Создать пост",
write_caption: "Напишите что-нибудь...",
pics: "Фото",
posting: "Публикация...",
write_comment: "Написать комментарий...",
send: "Отправить",
weekly_spending: "Еженедельные расходы",
ride_log: "История поездок",
no_rides: "Поездок пока нет",


no_pickup_recorded: "Место посадки не записано",
no_destination_recorded: "Место назначения не записано",
      finance: "Финансы",
expired: "Истек",

// RUSSIAN
driver: "Водитель",
now: "Сейчас",
minutes_ago: "мин назад",
hours_ago: "ч назад",
days_ago: "дней назад",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Квитанция",
select_transaction_receipt: "Выберите транзакцию ниже для просмотра квитанции.",
post_failed: "Ошибка публикации",
monday: "Понедельник",
tuesday: "Вторник",
wednesday: "Среда",
thursday: "Четверг",
friday: "Пятница",
saturday: "Суббота",
sunday: "Воскресенье",
feed: "Лента",
live: "Прямой эфир",
recent: "Недавнее",
total_rides: "Всего поездок",
completed: "Завершено",
dropoff: "Место высадки",
not_logged: "Не записано",
no_history: "Нет истории",
ride_history_dashboard: "Панель Истории Поездок",
weekly_revenue: "Недельный доход",
total_revenue: "Общий доход",
search_passenger_location_phone: "Поиск пассажира, места, телефона...",
all: "Все",
accepted: "Принято",
export: "Экспорт",
receipts: "Квитанции",
no_phone: "Нет телефона",
no_ride_history: "Истории поездок пока нет.",
whats_happening: "Что происходит в KinaHub?",
video_selected: "Видео выбрано",
image_selected: "Изображение выбрано",
remove: "Удалить",
pictures: "Изображения",
videos: "Видео",
mood: "Настроение",
post: "Пост",
public: "Публичный",
likes: "лайки",
comments: "комментарии",
shares: "поделиться",
like: "Лайк",
comment: "Комментарий",
share: "Поделиться",
post_link_copied: "Ссылка скопирована",
write_comment: "Написать комментарий...",
private_account_section: "Это приватный раздел аккаунта.",
kinatrip_finance_wallet: "Финансовый Кошелек KinaTrip",
lifetime_gross_earnings: "Общий доход",
available_balance: "Доступный баланс",
today: "Сегодня",
this_week: "На этой неделе",
this_month: "В этом месяце",
this_year: "В этом году",
finance_actions: "Финансовые действия",
transaction_records: "История транзакций",
export_report: "Экспорт отчета",
tax_summary: "Налоговая сводка",
weekly_earnings: "Доход с понедельника по воскресенье",
search_transaction: "Поиск транзакции, пассажира, телефона...",
passenger_ride: "Поездка пассажира",
gross: "Валовый",
platform_fee: "Комиссия платформы",
net: "Чистый",
no_finance_transactions: "Нет финансовых транзакций.",
kinahub_live_center: "Центр Live KinaHub",
go_live: "Начать эфир",
upload_reel: "Загрузить Reel",
online_status: "Онлайн статус",
safety_alert: "Предупреждение безопасности",
owner: "Владелец",
viewer: "Зритель",
access: "Доступ",
visibility: "Видимость",
no_live_videos: "Нет прямых эфиров.",
live_link_copied: "Ссылка скопирована",


   service_taxi: "Такси",
service_bus: "Автобус",
service_rental: "Аренда авто",
service_boat: "Лодка",
service_delivery: "Грузовой автомобиль",
service_motorbike: "Мотоцикл",

      direct_ride_requested: "Прямой заказ поездки отправлен!",
      ride_broadcasted: "Запрос на поездку отправлен всем водителям!",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Наличные",
seller_location: "Местоположение продавца",
buyer_location: "Местоположение покупателя",
user: "Пользователь",
payment: "Оплата",
delivery: "Доставка",
status: "Статус",
buyer: "Покупатель",
send: "Отправить",
type_message: "Введите сообщение...",
complete_all_fields: "Заполните все поля.",
please_upload_receipt: "Пожалуйста загрузите чек.",
cash_deposit_success: "Наличный депозит успешно отправлен.",


assign_kinatrip_driver: "Назначить водителя KinaTrip",
buyer_confirm_received: "Покупатель подтвердил получение",
release_escrow_to_seller: "Освободить эскроу продавцу",


paypal_payment: "Оплата PayPal", // Russian
category_electronics: "Электроника",
category_fashion: "Мода",
category_home: "Дом и быт",
category_food: "Еда",
category_auto_parts: "Автозапчасти",
category_stationery: "Канцелярия",
category_services: "Услуги",
category_other: "Другое",
// Russian
ride_accepted_success: "Поездка успешно принята!",
receipt_uploaded: "Квитанция успешно загружена",
no_file_selected: "Файл не выбран",
market_item: "Товар на рынке",

market_buy_message: "Здравствуйте, я хочу купить этот товар:",
for_price: "за",
all_listings: "Все объявления",
driver_listings: "Объявления водителей",
passenger_listings: "Объявления пассажиров",
business_listings: "Бизнес-объявления",
verified_sellers: "Проверенные продавцы",

seller_orders: "Заказы / Чаты продавца",
accept_order: "Принять заказ",
seller_review: "Проверка продавцом",
awaiting_payment: "Ожидание оплаты",
escrow_holding: "Средства удерживаются",
driver_assigned: "Водитель назначен",
delivered: "Доставлено",
escrow_released: "Эскроу освобождено",

cash_deposit_verification:
  "Проверка наличного депозита",

deposit_instruction:
  "Внесите оплату на утвержденный счет KinaTrip и отправьте данные ниже.",

submit_cash_deposit:
  "Отправить наличный депозит",

loading_chat: "Загрузка чата...",

payment_failed_start:
  "Не удалось начать оплату",


premium: "Премиум",
days_label: "Дней",
select_payment_type: "Выберите способ оплаты",
cash_deposit: "Наличный депозит",
amount_paid: "Оплаченная сумма",
pay: "Оплатить",
securely_using: "с использованием безопасной системы",
stripe_payment: "Stripe — Международные платежи",
flutterwave_payment: "Flutterwave — Африка",
xendit_payment: "Xendit — Азия",
activate_free_trial: "Активировать бесплатный пробный период",
trial_active: "Пробный период активен",
trial_activated_success: "Пробная лицензия успешно активирована!",
submit_cash_payment: "Отправить наличный платеж",
payment_screenshot_alt: "Скриншот оплаты",


license_trial: "Пробная лицензия",
license_standard: "Стандартная лицензия",
license_silver: "Серебряная лицензия",
license_gold: "Золотая лицензия",

free: "Бесплатно",
fee: "Стоимость",
validity: "Срок действия",
daily_limit: "Дневной лимит",
passengers: "Пассажиры",
unlimited_passengers: "Неограниченное количество пассажиров",

select_license_plan: "Выберите план лицензии",

online_card_payment: "Онлайн-оплата картой",

secure_payment_text:
  "Данные вашей карты защищены сертифицированными платежными системами.",

cash_deposit_payment: "Ручной / локальный партнерский платеж",

pay_through_partner:
  "Оплатите через утвержденного партнера KinaTrip или местного агента.",

country: "Страна",
plan: "План",
amount: "Сумма",

phone_number: "Номер телефона",

receipt_reference:
  "Квитанция / Ссылка / Код партнера",

upload_receipt:
  "Загрузить квитанцию или скриншот оплаты",

submit_payment: "Отправить платеж",

waiting_approval:
  "Платеж успешно отправлен. Ожидание подтверждения администратора.",

back_to_payment_type:
  "Назад к способу оплаты",

select_user_type: "Выберите тип пользователя",
passenger: "Пассажир",
driver_service_provider: "Водитель / Поставщик услуг",
already_have_account: "Уже есть аккаунт? Войти",
dont_have_account: "Нет аккаунта? Зарегистрироваться",
login: "Войти",
signup: "Регистрация",
email: "Электронная почта",
password: "Пароль",
confirm_password: "Подтвердите пароль",
phone: "Телефон",
city: "Город",
state_province: "Область / Провинция",
full_name: "Полное имя",
business_service_name: "Название бизнеса / услуги",
upload_profile_photo: "Загрузить фото профиля:",
please_wait: "⌛ Пожалуйста подождите…",
select_service_default: "-- Выберите услугу --",
passwords_match: "✅ Пароли совпадают",
passwords_not_match: "❌ Пароли не совпадают",
strength: "Надёжность",

choose_file: "Выбрать файл",
weak: "Слабый",
medium: "Средний",
strong: "Сильный",

escrow_active: "Эскроу активен",
transport_provided_by_kinatrip: "Транспорт предоставлен KinaTrip",
list_item_for_sale: "Разместить товар на продажу",
what_are_you_selling_today: "Что вы продаете сегодня?",
enter_price: "Введите цену",
select_category: "Выберите категорию",
photo: "Фото",
price: "Цена",
category: "Категория",
post_item: "Опубликовать товар",
posting: "Публикация...",
trending_items: "Популярные товары",
no_market_items_yet: "Пока нет товаров.",
buy_now: "Купить сейчас",
market_item: "Товар рынка",
no_city: "Нет города",
no_country: "Нет страны",
escrow_description: "ЭСКРОУ KINATRIP: Средства надежно хранятся, пока вы не подтвердите получение товара. Оплатите онлайн, и наши водители доставят его к вашей двери.",


"Choose Driver": "Выберите водителя",
"With Driver": "С водителем",
"Self Driver": "Без водителя",
"Driver": "Водитель",

      passenger_vehicles: "Пассажирские транспортные средства",
marine: "Водный транспорт",
cargo_transport: "Груз и транспорт",
machinery_equipment: "Техника и оборудование",

vehicle_economy: "Эконом",
vehicle_sedan: "Седан",
vehicle_suv: "Внедорожник",
vehicle_van: "Фургон",
vehicle_minibus: "Микроавтобус",
vehicle_bus: "Автобус",
vehicle_pickup: "Пикап",
vehicle_luxury: "Люкс",
vehicle_taxi: "Такси",
vehicle_motorbike: "Мотоцикл",

vehicle_boat: "Лодка",

vehicle_cargo_van: "Грузовой фургон",
vehicle_truck: "Грузовик",
vehicle_trailer: "Прицеп",

vehicle_forklift: "Погрузчик",
vehicle_excavator: "Экскаватор",
vehicle_bulldozer: "Бульдозер",
vehicle_grader: "Грейдер",
vehicle_loader: "Погрузчик",
vehicle_roller: "Каток",
vehicle_crane: "Кран",
vehicle_tractor: "Трактор",
vehicle_generator: "Генератор",

vehicle_other: "Другое",


pickup_location: "Место подачи",
return_location: "Место возврата",
select_vehicle_type: "Выберите тип транспорта",
offer_per_day: "Предложение за день",
offer_per_day_label: "Цена / День",
total_will_be: "Итого будет",
grand_total: "Общая сумма",
request_rental: "Запросить аренду",
optional_rental_note: "Необязательно: нужен водитель, нужен кондиционер, ранняя подача, топливо включено...",

pickup_required: "Требуется место подачи",
return_required: "Требуется место возврата",
select_vehicle: "Выберите транспорт",
invalid_days: "Неверное количество дней",
offer_per_day_required: "Требуется цена за день",
pickup_date_required: "Требуется дата подачи",
pickup_time_required: "Требуется время подачи",
return_date_required: "Требуется дата возврата",
return_time_required: "Требуется время возврата",
return_must_be_after_pickup: "Возврат должен быть после подачи",

pickup: "Подача",
return: "Возврат",
vehicle: "Транспорт",
days: "Дни",
pickup_time: "Время подачи",
return_time: "Время возврата",
eta: "Ожидаемое время",
minutes: "мин"
    }
  },

  hi: {
    translation: {
      logout: "लॉग आउट", close: "बंद करें", cancel: "रद्द करें", back: "वापस", booking: "बुकिंग", gps_denied: "GPS अनुमति अस्वीकृत",
      wallet: "बटुआ", history: "इतिहास", inbox: "इनबॉक्स", ride_requests: "सवारी के अनुरोध", whatsapp_support: "WhatsApp सपोर्ट",
      menu: "मेनू", wallet_balance: "बटुआ बैलेंस", pending_savings: "लंबित बचत", last_ride_info: "अंतिम सवारी की जानकारी",
      select_pickup: "पिकअप चुनने के लिए मैप पर क्लिक करें", select_destination: "गंतव्य चुनने के लिए मैप पर क्लिक करें", distance: "दूरी", fare: "किराया", savings: "बचत",
      select_service: "सेवा चुनें", request_ride: "सवारी का अनुरोध करें", call: "कॉल", chat: "चैट", accept_ride: "सवारी स्वीकार करें",
      new_request: "नया अनुरोध", your_passenger: "आपका यात्री", enter_key: "कुंजी दर्ज करें", phone: "फोन", area: "क्षेत्र", map: "मैप", license: "लाइसेंस", support: "सपोर्ट",
      kinamarket: "कीना मार्केट",
      whatsapp: "WhatsApp",
      accept_to_view: "संपर्क और क्षेत्र विवरण देखने के लिए सवारी स्वीकार करें",
install_global:
  "वैश्विक परिवहन और मार्केटप्लेस प्लेटफ़ॉर्म",

install_services:
  "उपलब्ध सेवाएँ",

install_button:
  "KinaTrip ऐप इंस्टॉल करें",

app_screenshots:
  "ऐप स्क्रीनशॉट",

taxi_booking:
  "🚕 टैक्सी बुकिंग",

bus_transport:
  "🚌 बस परिवहन",

motorbike:
  "🏍 मोटरसाइकिल",

boat_transport:
  "🚤 नाव परिवहन",

delivery_services:
  "📦 डिलीवरी सेवाएँ",

rental_cars:
  "🚗 किराये की कारें",

copyright:
  "© 2026 KinaTrip Technologies Ltd. सर्वाधिकार सुरक्षित।",
pickup: "पिकअप",
dropoff: "ड्रॉप ऑफ",





signup_failed:
  "साइनअप विफल हुआ। कृपया पुनः प्रयास करें।",

email_already_exists:
  "यह ईमेल पहले से पंजीकृत है।",

invalid_email:
  "अमान्य ईमेल पता।",

weak_password_error:
  "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",

network_error:
  "नेटवर्क त्रुटि। अपना इंटरनेट कनेक्शन जांचें।",
complete_all_ride_fields:
  "कृपया सभी राइड विवरण भरें!",

complete_all_rental_fields:
  "कृपया सभी रेंटल विवरण भरें और मैप पर पिकअप स्थान चुनें!",
      back_to_map: "⬅ मानचित्र पर वापस जाएँ",
enter_fare: "किराया दर्ज करें",
click_pickup_map:
  "📍 पिकअप स्थान चुनने के लिए मानचित्र पर क्लिक करें",

click_dropoff_map:
  "🏁 गंतव्य चुनने के लिए मानचित्र पर क्लिक करें",

pickup_placeholder:
  "📍 पिकअप स्थान या मानचित्र पर क्लिक करें",

dropoff_placeholder:
  "🏁 गंतव्य स्थान या मानचित्र पर क्लिक करें",

back_to_menu: "⬅ मेनू पर वापस जाएँ",

select_date: "📅 तारीख चुनें",
select_time: "⏰ समय चुनें",

online: "ऑनलाइन",
offline: "ऑफलाइन",

search_location: "स्थान खोजें...",

driver_arriving: "ड्राइवर आ रहा है",
ride_completed: "यात्रा पूरी हुई",

payment_successful: "भुगतान सफल",
payment_failed: "भुगतान विफल",

withdraw_success: "निकासी सफल",
withdraw_pending: "निकासी लंबित",


ready: "तैयार",
locked: "लॉक",
withdrawal_unlocked: "निकासी खुल गई",
needed_unlock: "निकासी खोलने के लिए और चाहिए",
pending_withdrawals: "लंबित निकासी",
total_spent: "कुल खर्च",
total_saved: "कुल बचत",
withdrawn: "निकाला गया",
request_withdrawal: "निकासी अनुरोध",
wallet_transactions: "वॉलेट लेनदेन",
withdrawal_request: "निकासी अनुरोध",
ride_savings: "राइड बचत",
no_transactions: "अभी तक कोई लेनदेन नहीं",
processing: "प्रोसेस हो रहा है...",
enter_account: "फोन या अकाउंट नंबर",
enter_amount: "राशि दर्ज करें",
saved: "बचाया गया",
reply: "उत्तर",
reply_comment: "उत्तर लिखें...",
recent_drivers: "हाल के ड्राइवर",
no_recent_drivers: "कोई हालिया ड्राइवर नहीं",
create_post: "पोस्ट बनाएं",
write_caption: "कुछ लिखें...",
pics: "तस्वीरें",
posting: "पोस्ट हो रहा है...",
write_comment: "टिप्पणी लिखें...",
send: "भेजें",
weekly_spending: "साप्ताहिक खर्च",
ride_log: "राइड लॉग",
no_rides: "अभी तक कोई राइड नहीं",


no_pickup_recorded: "पिकअप रिकॉर्ड नहीं",
no_destination_recorded: "गंतव्य रिकॉर्ड नहीं",
      finance: "वित्त",
expired: "समाप्त",

// HINDI
driver: "ड्राइवर",
now: "अभी",
minutes_ago: "मिनट पहले",
hours_ago: "घंटे पहले",
days_ago: "दिन पहले",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "रसीद",
select_transaction_receipt: "रसीद देखने के लिए नीचे लेनदेन चुनें।",
post_failed: "पोस्ट विफल",
monday: "सोमवार",
tuesday: "मंगलवार",
wednesday: "बुधवार",
thursday: "गुरुवार",
friday: "शुक्रवार",
saturday: "शनिवार",
sunday: "रविवार",
feed: "फ़ीड",
live: "लाइव",
recent: "हाल का",
total_rides: "कुल राइड",
completed: "पूर्ण",
dropoff: "ड्रॉप-ऑफ",
not_logged: "रिकॉर्ड नहीं",
no_history: "कोई इतिहास नहीं",
ride_history_dashboard: "राइड इतिहास डैशबोर्ड",
weekly_revenue: "साप्ताहिक आय",
total_revenue: "कुल आय",
search_passenger_location_phone: "यात्री, स्थान, फोन खोजें...",
all: "सभी",
accepted: "स्वीकृत",
export: "एक्सपोर्ट",
receipts: "रसीदें",
no_phone: "फोन नहीं",
no_ride_history: "कोई राइड इतिहास नहीं।",
whats_happening: "KinaHub पर क्या हो रहा है?",
video_selected: "वीडियो चुना गया",
image_selected: "चित्र चुना गया",
remove: "हटाएँ",
pictures: "चित्र",
videos: "वीडियो",
mood: "मूड",
post: "पोस्ट",
public: "सार्वजनिक",
likes: "लाइक्स",
comments: "टिप्पणियाँ",
shares: "शेयर",
like: "लाइक",
comment: "टिप्पणी",
share: "शेयर",
post_link_copied: "पोस्ट लिंक कॉपी हुआ",
write_comment: "टिप्पणी लिखें...",
private_account_section: "यह निजी खाता अनुभाग है।",
kinatrip_finance_wallet: "KinaTrip वित्त वॉलेट",
lifetime_gross_earnings: "कुल आय",
available_balance: "उपलब्ध बैलेंस",
today: "आज",
this_week: "इस सप्ताह",
this_month: "इस महीने",
this_year: "इस वर्ष",
finance_actions: "वित्त कार्य",
transaction_records: "लेनदेन रिकॉर्ड",
export_report: "रिपोर्ट एक्सपोर्ट",
tax_summary: "टैक्स सारांश",
weekly_earnings: "सोमवार - रविवार आय",
search_transaction: "लेनदेन, यात्री, फोन खोजें...",
passenger_ride: "यात्री राइड",
gross: "सकल",
platform_fee: "प्लेटफ़ॉर्म शुल्क",
net: "शुद्ध",
no_finance_transactions: "कोई वित्त लेनदेन नहीं।",
kinahub_live_center: "KinaHub लाइव सेंटर",
go_live: "लाइव जाएँ",
upload_reel: "रील अपलोड करें",
online_status: "ऑनलाइन स्थिति",
safety_alert: "सुरक्षा चेतावनी",
owner: "मालिक",
viewer: "दर्शक",
access: "एक्सेस",
visibility: "दृश्यता",
no_live_videos: "कोई लाइव वीडियो नहीं।",
live_link_copied: "लाइव लिंक कॉपी हुआ",


    service_taxi: "टैक्सी",
service_bus: "बस",
service_rental: "किराये की कार",
service_boat: "नाव",
service_delivery: "डिलीवरी ट्रक",
service_motorbike: "मोटरसाइकिल",

      direct_ride_requested: "सीधी सवारी का अनुरोध किया गया!",
      ride_broadcasted: "सवारी अनुरोध सभी ड्राइवरों को भेज दिया गया!",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "नकद",
seller_location: "विक्रेता स्थान",
buyer_location: "खरीदार स्थान",
user: "उपयोगकर्ता",
payment: "भुगतान",
delivery: "डिलीवरी",
status: "स्थिति",
buyer: "खरीदार",
send: "भेजें",
type_message: "अपना संदेश लिखें...",
complete_all_fields: "सभी फ़ील्ड भरें।",
please_upload_receipt: "कृपया रसीद अपलोड करें।",
cash_deposit_success: "नकद जमा सफलतापूर्वक भेजा गया।",


assign_kinatrip_driver: "KinaTrip ड्राइवर नियुक्त करें",
buyer_confirm_received: "खरीदार ने प्राप्ति की पुष्टि की",
release_escrow_to_seller: "एस्क्रो विक्रेता को जारी करें",


paypal_payment: "PayPal भुगतान", // Hindi
category_electronics: "इलेक्ट्रॉनिक्स",
category_fashion: "फैशन",
category_home: "घर और जीवन",
category_food: "खाद्य",
category_auto_parts: "ऑटो पार्ट्स",
category_stationery: "स्टेशनरी",
category_services: "सेवाएं",
category_other: "अन्य",
// Hindi
ride_accepted_success: "राइड सफलतापूर्वक स्वीकार की गई!",
receipt_uploaded: "रसीद सफलतापूर्वक अपलोड की गई",
no_file_selected: "कोई फ़ाइल चयनित नहीं",
market_item: "मार्केट आइटम",

market_buy_message: "नमस्ते, मैं यह सामान खरीदना चाहता हूँ:",
for_price: "के लिए",
all_listings: "सभी लिस्टिंग",
driver_listings: "ड्राइवर लिस्टिंग",
passenger_listings: "यात्री लिस्टिंग",
business_listings: "व्यापार लिस्टिंग",
verified_sellers: "सत्यापित विक्रेता",



hi: {
  translation: {

    seller_orders: "विक्रेता ऑर्डर / चैट",
    accept_order: "ऑर्डर स्वीकार करें",
    seller_review: "विक्रेता समीक्षा",
    awaiting_payment: "भुगतान की प्रतीक्षा",
    escrow_holding: "एस्क्रो में धन सुरक्षित",
    driver_assigned: "ड्राइवर नियुक्त",
    delivered: "डिलीवर किया गया",
    escrow_released: "एस्क्रो जारी किया गया",

    cash_deposit_verification:
      "नकद जमा सत्यापन",

    deposit_instruction:
      "KinaTrip के स्वीकृत खाते में भुगतान जमा करें और नीचे विवरण जमा करें।",

    submit_cash_deposit:
      "नकद जमा भेजें",

    loading_chat:
      "चैट लोड हो रही है...",

    payment_failed_start:
      "भुगतान शुरू नहीं हो सका",

  }
},

hi: {
  translation: {
    seller_orders: "विक्रेता ऑर्डर / चैट",
    accept_order: "ऑर्डर स्वीकार करें",
    seller_review: "विक्रेता समीक्षा",
    awaiting_payment: "भुगतान की प्रतीक्षा",
    escrow_holding: "एस्क्रो में धन सुरक्षित",
    driver_assigned: "ड्राइवर नियुक्त",
    delivered: "डिलीवर किया गया",
    escrow_released: "एस्क्रो जारी किया गया",
    cash_deposit_verification: "नकद जमा सत्यापन",
    deposit_instruction:
      "KinaTrip के स्वीकृत खाते में भुगतान जमा करें और नीचे विवरण जमा करें।",
    submit_cash_deposit: "नकद जमा भेजें",
    loading_chat: "चैट लोड हो रही है...",
    payment_failed_start: "भुगतान शुरू नहीं हो सका",
  }
},

hi: {
  translation: {
    seller_orders: "विक्रेता ऑर्डर / चैट",
    accept_order: "ऑर्डर स्वीकार करें",
    seller_review: "विक्रेता समीक्षा",
    awaiting_payment: "भुगतान की प्रतीक्षा",
    escrow_holding: "एस्क्रो में धन सुरक्षित",
    driver_assigned: "ड्राइवर नियुक्त",
    delivered: "डिलीवर किया गया",
    escrow_released: "एस्क्रो जारी किया गया",
    buy_now: "अभी खरीदें",
    escrow_active: "एस्क्रो सक्रिय है",
    list_item_for_sale: "बिक्री के लिए आइटम सूचीबद्ध करें",
    what_are_you_selling_today:
      "आप आज क्या बेच रहे हैं?",

seller_orders: "विक्रेता ऑर्डर / चैट",
accept_order: "ऑर्डर स्वीकार करें",
seller_review: "विक्रेता समीक्षा",
awaiting_payment: "भुगतान की प्रतीक्षा",
escrow_holding: "एस्क्रो में धन सुरक्षित",
driver_assigned: "ड्राइवर नियुक्त",
delivered: "डिलीवर किया गया",
escrow_released: "एस्क्रो जारी किया गया",
cash_deposit_verification: "नकद जमा सत्यापन",
deposit_instruction:
  "KinaTrip के स्वीकृत खाते में भुगतान जमा करें और नीचे विवरण जमा करें।",
submit_cash_deposit: "नकद जमा भेजें",
loading_chat: "चैट लोड हो रही है...",
payment_failed_start: "भुगतान शुरू नहीं हो सका",

  }
},


assign_kinatrip_driver: "KinaTrip ड्राइवर नियुक्त करें",
buyer_confirm_received: "खरीदार ने प्राप्ति की पुष्टि की",
release_escrow_to_seller: "एस्क्रो विक्रेता को जारी करें",

premium: "प्रीमियम",
days_label: "दिन",
select_payment_type: "भुगतान प्रकार चुनें",
cash_deposit: "नकद जमा",
amount_paid: "भुगतान राशि",
pay: "भुगतान करें",
securely_using: "सुरक्षित भुगतान प्रणाली का उपयोग करके",
stripe_payment: "Stripe — अंतर्राष्ट्रीय भुगतान",
flutterwave_payment: "Flutterwave — अफ्रीका",
xendit_payment: "Xendit — एशिया",
activate_free_trial: "मुफ्त ट्रायल सक्रिय करें",
trial_active: "ट्रायल सक्रिय है",
trial_activated_success: "ट्रायल लाइसेंस सफलतापूर्वक सक्रिय हुआ!",
submit_cash_payment: "नकद भुगतान जमा करें",
payment_screenshot_alt: "भुगतान स्क्रीनशॉट",




license_trial: "ट्रायल लाइसेंस",
license_standard: "स्टैंडर्ड लाइसेंस",
license_silver: "सिल्वर लाइसेंस",
license_gold: "गोल्ड लाइसेंस",

free: "मुफ्त",
fee: "शुल्क",
validity: "वैधता",
daily_limit: "दैनिक सीमा",
passengers: "यात्री",
unlimited_passengers: "असीमित यात्री",

select_license_plan: "लाइसेंस योजना चुनें",

online_card_payment: "ऑनलाइन कार्ड भुगतान",

secure_payment_text:
  "आपके कार्ड विवरण प्रमाणित भुगतान गेटवे द्वारा सुरक्षित रखे जाते हैं।",

cash_deposit_payment: "मैनुअल / स्थानीय पार्टनर भुगतान",

pay_through_partner:
  "अपने स्वीकृत KinaTrip पार्टनर या स्थानीय भुगतान एजेंट के माध्यम से भुगतान करें।",

country: "देश",
plan: "योजना",
amount: "राशि",

phone_number: "फ़ोन नंबर",

receipt_reference:
  "रसीद / संदर्भ / पार्टनर कोड",

upload_receipt:
  "भुगतान रसीद या स्क्रीनशॉट अपलोड करें",

submit_payment: "भुगतान जमा करें",

waiting_approval:
  "भुगतान सफलतापूर्वक जमा किया गया। एडमिन स्वीकृति की प्रतीक्षा है।",

back_to_payment_type:
  "भुगतान प्रकार पर वापस जाएँ",

select_user_type: "उपयोगकर्ता प्रकार चुनें",
passenger: "यात्री",
driver_service_provider: "ड्राइवर / सेवा प्रदाता",
already_have_account: "क्या आपके पास पहले से खाता है? लॉगिन करें",
dont_have_account: "क्या आपके पास खाता नहीं है? साइनअप करें",
login: "लॉगिन",
signup: "साइनअप",
email: "ईमेल",
password: "पासवर्ड",
confirm_password: "पासवर्ड की पुष्टि करें",
phone: "फ़ोन",
city: "शहर",
state_province: "राज्य / प्रांत",
full_name: "पूरा नाम",
business_service_name: "व्यवसाय / सेवा का नाम",
upload_profile_photo: "प्रोफ़ाइल फोटो अपलोड करें:",
please_wait: "⌛ कृपया प्रतीक्षा करें…",
select_service_default: "-- सेवा चुनें --",
passwords_match: "✅ पासवर्ड मेल खाते हैं",
passwords_not_match: "❌ पासवर्ड मेल नहीं खाते",
strength: "मज़बूती",

choose_file: "फ़ाइल चुनें",
weak: "कमज़ोर",
medium: "मध्यम",
strong: "मज़बूत",

escrow_active: "एस्क्रो सक्रिय है",
transport_provided_by_kinatrip: "KinaTrip द्वारा परिवहन प्रदान किया गया",
list_item_for_sale: "बिक्री के लिए आइटम सूचीबद्ध करें",
what_are_you_selling_today: "आप आज क्या बेच रहे हैं?",
enter_price: "कीमत दर्ज करें",
select_category: "श्रेणी चुनें",
photo: "फोटो",
price: "कीमत",
category: "श्रेणी",
post_item: "आइटम पोस्ट करें",
posting: "पोस्ट किया जा रहा है...",
trending_items: "ट्रेंडिंग आइटम",
no_market_items_yet: "अभी कोई आइटम नहीं है।",
buy_now: "अभी खरीदें",
market_item: "मार्केट आइटम",
no_city: "कोई शहर नहीं",
no_country: "कोई देश नहीं",
escrow_description: "KINATRIP एस्क्रो: भुगतान सुरक्षित रखा जाता है जब तक आप अपने आइटम की प्राप्ति की पुष्टि नहीं करते। ऑनलाइन भुगतान करें और हमारे ड्राइवर इसे आपके दरवाजे तक पहुंचाते हैं।",


      "Choose Driver": "ड्राइवर चुनें",
"With Driver": "ड्राइवर के साथ",
"Self Driver": "खुद ड्राइव करें",
"Driver": "ड्राइवर",

      passenger_vehicles: "यात्री वाहन",
marine: "समुद्री परिवहन",
cargo_transport: "कार्गो और परिवहन",
machinery_equipment: "मशीन और उपकरण",

vehicle_economy: "इकोनॉमी",
vehicle_sedan: "सेडान",
vehicle_suv: "एसयूवी",
vehicle_van: "वैन",
vehicle_minibus: "मिनिबस",
vehicle_bus: "बस",
vehicle_pickup: "पिकअप",
vehicle_luxury: "लक्ज़री",
vehicle_taxi: "टैक्सी",
vehicle_motorbike: "मोटरसाइकिल",

vehicle_boat: "नाव",

vehicle_cargo_van: "कार्गो वैन",
vehicle_truck: "ट्रक",
vehicle_trailer: "ट्रेलर",

vehicle_forklift: "फोर्कलिफ्ट",
vehicle_excavator: "खुदाई मशीन",
vehicle_bulldozer: "बुलडोज़र",
vehicle_grader: "ग्रेडर",
vehicle_loader: "लोडर",
vehicle_roller: "रोलर",
vehicle_crane: "क्रेन",
vehicle_tractor: "ट्रैक्टर",
vehicle_generator: "जनरेटर",

vehicle_other: "अन्य",


pickup_location: "पिकअप स्थान",
return_location: "वापसी स्थान",
select_vehicle_type: "वाहन प्रकार चुनें",
offer_per_day: "प्रति दिन प्रस्ताव",
offer_per_day_label: "प्रस्ताव / दिन",
total_will_be: "कुल होगा",
grand_total: "कुल योग",
request_rental: "रेंटल अनुरोध भेजें",
optional_rental_note: "वैकल्पिक: ड्राइवर चाहिए, एसी चाहिए, जल्दी पिकअप, ईंधन शामिल...",

pickup_required: "पिकअप स्थान आवश्यक है",
return_required: "वापसी स्थान आवश्यक है",
select_vehicle: "वाहन चुनें",
invalid_days: "दिनों की संख्या अमान्य है",
offer_per_day_required: "प्रति दिन प्रस्ताव आवश्यक है",
pickup_date_required: "पिकअप तिथि आवश्यक है",
pickup_time_required: "पिकअप समय आवश्यक है",
return_date_required: "वापसी तिथि आवश्यक है",
return_time_required: "वापसी समय आवश्यक है",
return_must_be_after_pickup: "वापसी पिकअप के बाद होनी चाहिए",

pickup: "पिकअप",
return: "वापसी",
vehicle: "वाहन",
days: "दिन",
pickup_time: "पिकअप समय",
return_time: "वापसी समय",
eta: "अनुमानित समय",
minutes: "मिनट"
    }
  },

  id: {
    translation: {
      logout: "Keluar", close: "Tutup", cancel: "Batal", back: "Kembali", booking: "Pemesanan", gps_denied: "Izin GPS ditolak",
      wallet: "Dompet", history: "Riwayat", inbox: "Kotak Masuk", ride_requests: "Permintaan Perjalanan", whatsapp_support: "Dukungan WhatsApp",
      menu: "Menu", wallet_balance: "Saldo Dompet", pending_savings: "Tabungan Tertunda", last_ride_info: "Info Perjalanan Terakhir",
      select_pickup: "Klik pada peta untuk lokasi penjemputan", select_destination: "Klik untuk tujuan", distance: "Jarak", fare: "Tarif", savings: "Tabungan",
      select_service: "Pilih Layanan", request_ride: "Pesan Perjalanan", call: "Telepon", chat: "Obrolan", accept_ride: "Terima Perjalanan",
      new_request: "Permintaan Baru", your_passenger: "Penumpang Anda", enter_key: "Masukkan Kunci Produk", phone: "Telepon", area: "Area", map: "Peta", license: "Lisensi", support: "Dukungan",
      kinamarket: "Pasar Kina",
      whatsapp: "WhatsApp",
      accept_to_view: "Terima perjalanan untuk melihat detail kontak & area",
enter_fare: "Masukkan Tarif",





signup_failed:
  "Pendaftaran gagal. Silakan coba lagi.",

email_already_exists:
  "Email ini sudah terdaftar.",

invalid_email:
  "Alamat email tidak valid.",

weak_password_error:
  "Password minimal harus 6 karakter.",

network_error:
  "Kesalahan jaringan. Periksa koneksi internet Anda.",
complete_all_ride_fields:
  "Lengkapi semua detail perjalanan!",

complete_all_rental_fields:
  "Lengkapi semua detail rental dan pilih lokasi penjemputan di peta!",
pickup: "Jemput",
dropoff: "Turun",
install_global:
  "Platform Transportasi & Marketplace Global",

install_services:
  "Layanan Tersedia",

install_button:
  "Install Aplikasi KinaTrip",

app_screenshots:
  "Screenshot Aplikasi",

taxi_booking:
  "🚕 Pemesanan Taksi",

bus_transport:
  "🚌 Transportasi Bus",

motorbike:
  "🏍 Sepeda Motor",

boat_transport:
  "🚤 Transportasi Perahu",

delivery_services:
  "📦 Layanan Pengiriman",

rental_cars:
  "🚗 Mobil Rental",

copyright:
  "© 2026 KinaTrip Technologies Ltd. Hak cipta dilindungi.",
back_to_map: "⬅ Kembali ke Peta",
click_pickup_map:
  "📍 Klik peta untuk memilih lokasi jemput",

click_dropoff_map:
  "🏁 Klik peta untuk memilih tujuan",

pickup_placeholder:
  "📍 Lokasi jemput atau klik peta",

dropoff_placeholder:
  "🏁 Lokasi tujuan atau klik peta",

back_to_menu: "⬅ Kembali ke Menu",

select_date: "📅 Pilih Tanggal",
select_time: "⏰ Pilih Waktu",

online: "Online",
offline: "Offline",

search_location: "Cari lokasi...",

driver_arriving: "Pengemudi datang",
ride_completed: "Perjalanan selesai",

payment_successful: "Pembayaran berhasil",
payment_failed: "Pembayaran gagal",

withdraw_success: "Penarikan berhasil",
withdraw_pending: "Penarikan tertunda",



ready: "Siap",
locked: "Terkunci",
withdrawal_unlocked: "Penarikan terbuka",
needed_unlock: "dibutuhkan lagi untuk membuka penarikan",
pending_withdrawals: "Penarikan tertunda",
total_spent: "Total pengeluaran",
total_saved: "Total tabungan",
withdrawn: "Ditarik",
request_withdrawal: "Minta Penarikan",
wallet_transactions: "Transaksi dompet",
withdrawal_request: "Permintaan penarikan",
ride_savings: "Tabungan perjalanan",
no_transactions: "Belum ada transaksi",
processing: "Memproses...",
enter_account: "Nomor telepon atau rekening",
enter_amount: "Masukkan jumlah",
saved: "Disimpan",
reply: "Balas",
reply_comment: "Tulis balasan...",
recent_drivers: "Driver terbaru",
no_recent_drivers: "Belum ada driver terbaru",
create_post: "Buat postingan",
write_caption: "Tulis sesuatu...",
pics: "Foto",
posting: "Memposting...",
write_comment: "Tulis komentar...",
send: "Kirim",
weekly_spending: "Pengeluaran mingguan",
ride_log: "Riwayat perjalanan",
no_rides: "Belum ada perjalanan",



no_pickup_recorded: "Lokasi jemput belum tercatat",
no_destination_recorded: "Lokasi tujuan belum tercatat",
finance: "Keuangan",
expired: "Kedaluwarsa",

// INDONESIAN
driver: "Pengemudi",
now: "Sekarang",
minutes_ago: "mnt lalu",
hours_ago: "jam lalu",
days_ago: "hari lalu",
kinahub: "KinaHub",
driver_icon: "🚕",
user_icon: "👤",
receipt: "Struk",
select_transaction_receipt: "Pilih transaksi di bawah untuk melihat struk.",
post_failed: "Posting gagal",
monday: "Senin",
tuesday: "Selasa",
wednesday: "Rabu",
thursday: "Kamis",
friday: "Jumat",
saturday: "Sabtu",
sunday: "Minggu",
feed: "Feed",
live: "Live",
recent: "Terbaru",
total_rides: "Total Perjalanan",
completed: "Selesai",
dropoff: "Tujuan",
not_logged: "Tidak tercatat",
no_history: "Tidak ada riwayat",
ride_history_dashboard: "Dashboard Riwayat",
weekly_revenue: "Pendapatan Mingguan",
total_revenue: "Total Pendapatan",
search_passenger_location_phone: "Cari penumpang, lokasi, telepon...",
all: "Semua",
accepted: "Diterima",
export: "Ekspor",
receipts: "Struk",
no_phone: "Tidak ada telepon",
no_ride_history: "Belum ada riwayat perjalanan.",
whats_happening: "Apa yang terjadi di KinaHub?",
video_selected: "Video dipilih",
image_selected: "Gambar dipilih",
remove: "Hapus",
pictures: "Gambar",
videos: "Video",
mood: "Mood",
post: "Posting",
public: "Publik",
likes: "suka",
comments: "komentar",
shares: "dibagikan",
like: "Suka",
comment: "Komentar",
share: "Bagikan",
post_link_copied: "Link disalin",
write_comment: "Tulis komentar...",
private_account_section: "Ini adalah bagian akun pribadi.",
kinatrip_finance_wallet: "Dompet Keuangan KinaTrip",
lifetime_gross_earnings: "Total Pendapatan Kotor",
available_balance: "Saldo Tersedia",
today: "Hari Ini",
this_week: "Minggu Ini",
this_month: "Bulan Ini",
this_year: "Tahun Ini",
finance_actions: "Aksi Keuangan",
transaction_records: "Catatan Transaksi",
export_report: "Ekspor Laporan",
tax_summary: "Ringkasan Pajak",
weekly_earnings: "Pendapatan Senin - Minggu",
search_transaction: "Cari transaksi, penumpang, telepon...",
passenger_ride: "Perjalanan Penumpang",
gross: "Kotor",
platform_fee: "Biaya Platform",
net: "Bersih",
no_finance_transactions: "Belum ada transaksi keuangan.",
kinahub_live_center: "Pusat Live KinaHub",
go_live: "Siaran Langsung",
upload_reel: "Unggah Reel",
online_status: "Status Online",
safety_alert: "Peringatan Keamanan",
owner: "Pemilik",
viewer: "Penonton",
access: "Akses",
visibility: "Visibilitas",
no_live_videos: "Belum ada video live.",
live_link_copied: "Link live disalin",



     service_taxi: "Taksi",
service_bus: "Bus",
service_rental: "Sewa mobil",
service_boat: "Perahu",
service_delivery: "Truk pengiriman",
service_motorbike: "Motor",

      direct_ride_requested: "Perjalanan langsung diminta!",
      ride_broadcasted: "Permintaan perjalanan dikirim ke semua pengemudi!",


stripe: "Stripe",
flutterwave: "Flutterwave",
xendit: "Xendit",
paypal: "PayPal",
cash: "Tunai",
seller_location: "Lokasi Penjual",
buyer_location: "Lokasi Pembeli",
user: "Pengguna",
payment: "Pembayaran",
delivery: "Pengiriman",
status: "Status",
buyer: "Pembeli",
send: "Kirim",
type_message: "Tulis pesan...",
complete_all_fields: "Lengkapi semua kolom.",
please_upload_receipt: "Silakan upload bukti pembayaran.",
cash_deposit_success: "Deposit tunai berhasil dikirim.",


assign_kinatrip_driver: "Tetapkan Driver KinaTrip",
buyer_confirm_received: "Pembeli Mengonfirmasi Penerimaan",
release_escrow_to_seller: "Lepaskan Escrow ke Penjual",


paypal_payment: "Pembayaran PayPal", // Indonesian
category_electronics: "Elektronik",
category_fashion: "Fashion",
category_home: "Rumah & kehidupan",
category_food: "Makanan",
category_auto_parts: "Suku cadang mobil",
category_stationery: "Alat tulis",
category_services: "Layanan",
category_other: "Lainnya",
// Indonesian
ride_accepted_success: "Perjalanan berhasil diterima!",
receipt_uploaded: "Bukti pembayaran berhasil diunggah",
no_file_selected: "Belum ada file dipilih",
market_item: "Barang Pasar",

market_buy_message: "Halo, saya ingin membeli barang ini:",
for_price: "seharga",
all_listings: "Semua Listing",
driver_listings: "Listing Driver",
passenger_listings: "Listing Penumpang",
business_listings: "Listing Bisnis",
verified_sellers: "Penjual Terverifikasi",



seller_orders: "Pesanan / Chat Penjual",
accept_order: "Terima Pesanan",
seller_review: "Tinjauan Penjual",
awaiting_payment: "Menunggu Pembayaran",
escrow_holding: "Dana Ditahan Escrow",
driver_assigned: "Pengemudi Ditugaskan",
delivered: "Terkirim",
escrow_released: "Escrow Dilepaskan",
cash_deposit_verification: "Verifikasi Deposit Tunai",
deposit_instruction:
  "Setorkan pembayaran ke akun KinaTrip yang disetujui dan kirim detail di bawah.",
submit_cash_deposit: "Kirim Deposit Tunai",
loading_chat: "Memuat chat...",
payment_failed_start: "Gagal memulai pembayaran",


premium: "Premium",
days_label: "Hari",
select_payment_type: "Pilih Jenis Pembayaran",
cash_deposit: "Setoran Tunai",
amount_paid: "Jumlah Dibayar",
pay: "Bayar",
securely_using: "menggunakan sistem pembayaran aman",
stripe_payment: "Stripe — Pembayaran Internasional",
flutterwave_payment: "Flutterwave — Afrika",
xendit_payment: "Xendit — Asia",
activate_free_trial: "Aktifkan Uji Coba Gratis",
trial_active: "Uji Coba Aktif",
trial_activated_success: "Lisensi uji coba berhasil diaktifkan!",
submit_cash_payment: "Kirim Pembayaran Tunai",
payment_screenshot_alt: "Screenshot Pembayaran",




license_trial: "Lisensi Percobaan",
license_standard: "Lisensi Standar",
license_silver: "Lisensi Silver",
license_gold: "Lisensi Gold",

free: "Gratis",
fee: "Biaya",
validity: "Masa Berlaku",
daily_limit: "Batas Harian",
passengers: "Penumpang",
unlimited_passengers: "Penumpang Tidak Terbatas",

select_license_plan: "Pilih Paket Lisensi",

online_card_payment: "Pembayaran Kartu Online",

secure_payment_text:
  "Detail kartu Anda diamankan oleh gateway pembayaran bersertifikat.",

cash_deposit_payment: "Pembayaran Manual / Mitra Lokal",

pay_through_partner:
  "Bayar melalui Mitra Negara KinaTrip atau agen pembayaran lokal yang disetujui.",

country: "Negara",
plan: "Paket",
amount: "Jumlah",

phone_number: "Nomor Telepon",

receipt_reference:
  "Kwitansi / Referensi / Kode Mitra",

upload_receipt:
  "Unggah Bukti Pembayaran / Screenshot",

submit_payment: "Kirim Pembayaran",

waiting_approval:
  "Pembayaran berhasil dikirim. Menunggu persetujuan admin.",

back_to_payment_type:
  "Kembali ke Jenis Pembayaran",


select_user_type: "Pilih jenis pengguna",
passenger: "Penumpang",
driver_service_provider: "Pengemudi / Penyedia layanan",
already_have_account: "Sudah punya akun? Login",
dont_have_account: "Belum punya akun? Signup",
login: "Login",
signup: "Daftar",
email: "Email",
password: "Kata sandi",
confirm_password: "Konfirmasi kata sandi",
phone: "Telepon",
city: "Kota",
state_province: "Provinsi",
full_name: "Nama lengkap",
business_service_name: "Nama bisnis / layanan",
upload_profile_photo: "Upload foto profil:",
please_wait: "⌛ Harap tunggu…",
select_service_default: "-- Pilih layanan --",
passwords_match: "✅ Kata sandi cocok",
passwords_not_match: "❌ Kata sandi tidak cocok",
strength: "Kekuatan",

choose_file: "Pilih file",
weak: "Lemah",
medium: "Sedang",
strong: "Kuat",

escrow_active: "Escrow aktif",
transport_provided_by_kinatrip: "Transportasi disediakan oleh KinaTrip",
list_item_for_sale: "Jual barang",
what_are_you_selling_today: "Apa yang Anda jual hari ini?",
enter_price: "Masukkan harga",
select_category: "Pilih kategori",
photo: "Foto",
price: "Harga",
category: "Kategori",
post_item: "Posting barang",
posting: "Sedang memposting...",
trending_items: "Barang tren",
no_market_items_yet: "Belum ada barang.",
buy_now: "Beli sekarang",
market_item: "Barang pasar",
no_city: "Tidak ada kota",
no_country: "Tidak ada negara",
escrow_description: "ESCROW KINATRIP: Dana disimpan dengan aman sampai Anda mengonfirmasi penerimaan barang. Bayar online dan driver kami akan mengantarkannya ke pintu Anda.",



"Choose Driver": "Pilih pengemudi",
"With Driver": "Dengan pengemudi",
"Self Driver": "Tanpa pengemudi",
"Driver": "Pengemudi",


      passenger_vehicles: "Kendaraan penumpang",
marine: "Transportasi laut",
cargo_transport: "Kargo dan transportasi",
machinery_equipment: "Mesin dan peralatan",

vehicle_economy: "Ekonomi",
vehicle_sedan: "Sedan",
vehicle_suv: "SUV / 4WD",
vehicle_van: "Van",
vehicle_minibus: "Minibus",
vehicle_bus: "Bus",
vehicle_pickup: "Pickup",
vehicle_luxury: "Mewah",
vehicle_taxi: "Taksi",
vehicle_motorbike: "Motor",

vehicle_boat: "Perahu",

vehicle_cargo_van: "Van kargo",
vehicle_truck: "Truk",
vehicle_trailer: "Trailer",

vehicle_forklift: "Forklift",
vehicle_excavator: "Ekskavator",
vehicle_bulldozer: "Bulldozer",
vehicle_grader: "Grader",
vehicle_loader: "Loader",
vehicle_roller: "Roller",
vehicle_crane: "Crane",
vehicle_tractor: "Traktor",
vehicle_generator: "Generator",

vehicle_other: "Lainnya",


pickup_location: "Lokasi penjemputan",
return_location: "Lokasi pengembalian",
select_vehicle_type: "Pilih jenis kendaraan",
offer_per_day: "Penawaran per hari",
offer_per_day_label: "Penawaran / Hari",
total_will_be: "Total akan menjadi",
grand_total: "Total keseluruhan",
request_rental: "Minta sewa",
optional_rental_note: "Opsional: perlu sopir, perlu AC, penjemputan lebih awal, bahan bakar termasuk...",

pickup_required: "Lokasi penjemputan wajib diisi",
return_required: "Lokasi pengembalian wajib diisi",
select_vehicle: "Pilih kendaraan",
invalid_days: "Jumlah hari tidak valid",
offer_per_day_required: "Penawaran per hari wajib diisi",
pickup_date_required: "Tanggal penjemputan wajib diisi",
pickup_time_required: "Waktu penjemputan wajib diisi",
return_date_required: "Tanggal pengembalian wajib diisi",
return_time_required: "Waktu pengembalian wajib diisi",
return_must_be_after_pickup: "Pengembalian harus setelah penjemputan",

pickup: "Penjemputan",
return: "Pengembalian",
vehicle: "Kendaraan",
days: "Hari",
pickup_time: "Waktu penjemputan",
return_time: "Waktu pengembalian",
eta: "Perkiraan waktu",
minutes: "mnt"
    }
  }
};

/* ================= LANGUAGE SETUP ================= */

const savedLang = localStorage.getItem("lang");
const browserLang = navigator.language?.split("-")[0];

const supportedLangs = ["en", "tpi", "fr", "es", "pt", "zh", "ar", "ru", "hi", "id"];

const defaultLang = supportedLangs.includes(savedLang)
  ? savedLang
  : supportedLangs.includes(browserLang)
  ? browserLang
  : "en";

/* ================= INIT ================= */

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLang,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

/* ================= EXPORT FUNCTION ================= */

export const changeLanguage = (lang) => {
  if (!supportedLangs.includes(lang)) return;

  i18n.changeLanguage(lang);
  localStorage.setItem("lang", lang);
};

/* ================= DEFAULT EXPORT ================= */

export default i18n;